<template>
  <div class="bg-white p-3 lg:p-6 rounded-2xl cardShadow w-full  ">
    <div class="spin-loading" v-show="isLoading">
      <div style="border-top-color:transparent"
        class="w-11 h-11 border-4 border-green border-solid rounded-full animate-spin"></div>
    </div>

    <h2 class="labelStyle mb-2" v-show="isMobile || isQRPay || (isApplePaySupported && show_apple_pay) || show_google_pay">{{ $t('tabs.select_payment_method') }} </h2>
    <div class="">

      <div class="grid grid-cols-1 gap-1 mb-4" :class="(isApplePaySupported && show_apple_pay && show_google_pay) ? 'md:grid-cols-2' : 'md:grid-cols-1'">
       <div class="relative w-full" v-show="isApplePaySupported && show_apple_pay"
          @click="startApplePaySession">
          <button class="bg-black text-white py-2 px-1 rounded flex items-center justify-center space-x-2 w-full">
            <svg width="54" height="22" viewBox="0 0 54 22" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg"
              style="width: 42px;">
              <path
                d="M10.0031 2.84025C9.37516 3.58335 8.37041 4.16946 7.36565 4.08573C7.24005 3.08098 7.73197 2.01342 8.30761 1.35405C8.93558 0.590015 10.0345 0.0457711 10.9242 0.00390625C11.0288 1.05053 10.6206 2.07622 10.0031 2.84025ZM10.9137 4.28459C9.45889 4.20086 8.21341 5.11142 7.52264 5.11142C6.8214 5.11142 5.76432 4.32646 4.61303 4.34739C3.11636 4.36832 1.72435 5.21609 0.96032 6.56623C-0.609614 9.26651 0.552137 13.2646 2.06974 15.4625C2.81284 16.551 3.70247 17.7442 4.87469 17.7023C5.98411 17.6604 6.42369 16.9801 7.76336 16.9801C9.11351 16.9801 9.50076 17.7023 10.673 17.6814C11.8871 17.6604 12.6511 16.5929 13.3942 15.5044C14.242 14.2694 14.5873 13.0658 14.6083 13.003C14.5873 12.982 12.2638 12.0924 12.2429 9.41304C12.222 7.17327 14.0745 6.10571 14.1582 6.04292C13.1116 4.49392 11.4789 4.32646 10.9137 4.28459ZM19.3181 1.24939V17.5662H21.8509V11.9877H25.3571C28.5597 11.9877 30.81 9.78982 30.81 6.60809C30.81 3.42636 28.6016 1.24939 25.4408 1.24939H19.3181ZM21.8509 3.3845H24.771C26.9689 3.3845 28.2248 4.55671 28.2248 6.61856C28.2248 8.6804 26.9689 9.86309 24.7605 9.86309H21.8509V3.3845ZM35.4361 17.6918C37.0269 17.6918 38.5027 16.8859 39.1725 15.609H39.2248V17.5662H41.5693V9.44444C41.5693 7.08954 39.6853 5.57194 36.7862 5.57194C34.0964 5.57194 32.1078 7.11047 32.0345 9.22465H34.3162C34.5046 8.21989 35.4361 7.56052 36.7129 7.56052C38.2619 7.56052 39.1306 8.28269 39.1306 9.6119V10.512L35.9698 10.7004C33.0288 10.8783 31.438 12.0819 31.438 14.1752C31.438 16.2893 33.0812 17.6918 35.4361 17.6918ZM36.1164 15.7556C34.7662 15.7556 33.908 15.1067 33.908 14.1124C33.908 13.0867 34.7348 12.4901 36.3152 12.3959L39.1306 12.218V13.139C39.1306 14.6671 37.8328 15.7556 36.1164 15.7556ZM44.6987 22.0039C47.1687 22.0039 48.3304 21.0619 49.3457 18.2047L53.7938 5.72893H51.2191L48.2362 15.3683H48.1839L45.201 5.72893H42.5531L46.8442 17.6081L46.614 18.3303C46.2267 19.5548 45.5988 20.0258 44.4789 20.0258C44.28 20.0258 43.8928 20.0049 43.7358 19.9839V21.9411C43.8823 21.983 44.5103 22.0039 44.6987 22.0039Z"
                fill="white" />
            </svg>
          </button>
        </div>
        <div class="relative w-full" v-show="show_google_pay">
          <div ref="buttonContainer" class="flex items-center justify-center  w-full " />
        </div>
      </div>
      <div class="relative my-4"  v-show="(isApplePaySupported && show_apple_pay) || show_google_pay">
        <div class="absolute inset-0 flex items-center" aria-hidden="true">
          <div class="w-full border-t border-gray-300"></div>
        </div>
        <div class="relative flex justify-center">
          <span class="bg-white px-2 text-sm text-gray-500">
            {{ $t('tabs.Or_pay_with') }}
          </span>
        </div>
      </div>
    </div>

    <div v-show="isMobile || isQRPay" class="grid grid-cols-1 gap-1 mb-4" :class="isMobile && isQRPay ? 'md:grid-cols-3' : isMobile || isQRPay ? 'md:grid-cols-2' : 'md:grid-cols-1'">
      <button id="tab-bank-card" role="tab" :aria-selected="selectedTab === 'bank-card'" aria-controls="panel-bank-card"
        :class="selectedTab === 'bank-card' ? 'selectedTab' : 'unselectedTab'" @click="selectTab('bank-card')"
        class="flex-1 font-normal py-2 rounded flex items-center justify-center tabsBtnStyle">
        <svg
          :class="[selectedTab === 'bank-card' ? 'text-white' : 'text-current', isRtl ? 'order-2 ml-2 mr-0' : 'mr-2 ml-0']"
          width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0.32698 4.63803C0.13596 5.01293 0.0565325 5.45552 0.0235064 6.09375H23.9765C23.9435 5.45552 23.864 5.01293 23.673 4.63803C23.3854 4.07354 22.9265 3.6146 22.362 3.32698C21.7202 3 20.8802 3 19.2 3H4.8C3.11984 3 2.27976 3 1.63803 3.32698C1.07354 3.6146 0.614601 4.07354 0.32698 4.63803ZM24 9.1875H0V14.7C0 16.3802 0 17.2202 0.32698 17.862C0.614601 18.4265 1.07354 18.8854 1.63803 19.173C2.27976 19.5 3.11984 19.5 4.8 19.5H19.2C20.8802 19.5 21.7202 19.5 22.362 19.173C22.9265 18.8854 23.3854 18.4265 23.673 17.862C24 17.2202 24 16.3802 24 14.7V9.1875ZM2 15.375H8V17.4375H2V15.375Z"
            fill="#3C90A8" />
        </svg>
        {{ $t('tabs.bank_card') }}
      </button>
      <button v-show="isMobile" id="deep-link" role="tab" :aria-selected="selectedTab === 'deep-link'" aria-controls="panel-deep-link"
        :class="selectedTab === 'deep-link' ? 'selectedTab' : 'unselectedTab'" @click="selectTab('deep-link')"
        class="flex-1 font-normal py-2 rounded flex items-center justify-center tabsBtnStyle">
        <svg
          :class="[selectedTab === 'deep-link' ? 'text-white' : 'text-current', isRtl ? 'order-2 ml-2 mr-0' : 'mr-2 ml-0']"
          class="h-6 w-6 " width="58" height="50" viewBox="0 0 58 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.70991 21.9645H9.82864C9.98314 21.9645 10.1376 21.9727 10.2921 21.9793C10.3307 21.9878 10.3657 22.0083 10.3919 22.0378C10.4182 22.0673 10.4345 22.1043 10.4384 22.1437C10.4384 22.2406 10.4466 22.3359 10.4499 22.4329C10.4932 23.9799 10.7272 25.5156 11.1468 27.0053C12.0671 30.2502 13.8538 33.1833 16.315 35.4896C18.7763 37.7959 21.8191 39.3884 25.1169 40.0962C26.5365 40.3952 27.9858 40.5297 29.4362 40.4972C30.5574 40.4796 31.6743 40.353 32.771 40.1192C34.4604 39.7735 36.0919 39.1885 37.6161 38.3819C38.9535 37.6782 40.2007 36.8151 41.3306 35.8114C43.0714 34.268 44.5055 32.4101 45.5578 30.3351C46.2823 28.9235 46.8141 27.421 47.1389 25.8679C47.3181 25.0561 47.4363 24.2321 47.4922 23.4026C47.5169 22.9588 47.5514 22.5167 47.581 22.073C47.5851 22.035 47.6022 21.9997 47.6295 21.973C47.6568 21.9463 47.6925 21.9299 47.7305 21.9267C47.8456 21.9267 47.9623 21.9136 48.0773 21.9136L56.5466 21.9004C56.6435 21.9004 56.7405 21.9004 56.8358 21.9004C56.9772 21.9004 57.0593 21.9777 57.0577 22.1108C57.0577 22.4198 57.0445 22.7288 57.033 23.0378C57.033 23.1922 57.0067 23.3468 57.0002 23.5013C56.9027 25.5683 56.564 27.6169 55.991 29.6054C55.1571 32.5702 53.8327 35.3745 52.0728 37.902C49.7332 41.2876 46.6767 44.1163 43.1204 46.1871C40.7149 47.5958 38.1107 48.6337 35.3957 49.2655C34.398 49.4963 33.3885 49.6724 32.3716 49.7931C30.9892 49.9574 29.5969 50.0239 28.2052 49.992C27.3735 49.9755 26.5468 49.8934 25.7218 49.8013C25.1646 49.7389 24.6124 49.6517 24.0585 49.5597C22.7256 49.3332 21.4123 49.0035 20.1304 48.5736C16.4793 47.3531 13.1176 45.3959 10.2538 42.8232C7.38989 40.2505 5.08478 37.1172 3.48125 33.6173C2.56585 31.6325 1.89369 29.5442 1.47941 27.3981C1.32984 26.619 1.20494 25.8384 1.12276 25.0495C1.03237 24.185 0.958406 23.3188 0.943614 22.4477C0.938568 22.3515 0.944637 22.255 0.961696 22.1601C0.970768 22.1342 0.985285 22.1105 1.00428 22.0906C1.02327 22.0708 1.0463 22.0552 1.0718 22.045C1.14531 22.023 1.22191 22.013 1.29861 22.0155C1.53035 22.0155 1.7621 22.0155 1.99549 22.0155L5.70661 21.9843L5.70991 21.9645Z"
            fill="#3C90A8" />
          <path
            d="M42.0069 18.5097C42.0036 19.5992 41.6772 20.6633 41.0689 21.5672C40.4606 22.4711 39.5978 23.1742 38.5897 23.5875C37.5817 24.0008 36.4736 24.1058 35.4059 23.889C34.3381 23.6723 33.3587 23.1438 32.5915 22.3701C31.8243 21.5965 31.3039 20.6127 31.0962 19.5431C30.8884 18.4736 31.0026 17.3665 31.4243 16.3619C31.8461 15.3573 32.5564 14.5004 33.4654 13.8997C34.3743 13.299 35.4411 12.9815 36.5306 12.9874C37.2531 12.9893 37.9681 13.1338 38.6346 13.4126C39.3012 13.6913 39.9061 14.0989 40.4149 14.6119C40.9236 15.1249 41.3261 15.7333 41.5993 16.4022C41.8725 17.071 42.011 17.7872 42.0069 18.5097Z"
            fill="#3C90A8" />
          <path
            d="M34.1204 5.52243C34.1165 6.61129 33.7896 7.67451 33.1811 8.5775C32.5727 9.48049 31.71 10.1827 30.7023 10.5951C29.6945 11.0076 28.5871 11.1118 27.5201 10.8946C26.4531 10.6774 25.4746 10.1485 24.7083 9.3749C23.9421 8.60128 23.4226 7.6177 23.2156 6.54869C23.0086 5.47968 23.1234 4.37328 23.5455 3.36956C23.9676 2.36583 24.678 1.5099 25.5868 0.910099C26.4955 0.310302 27.5618 -0.00639951 28.6507 9.80092e-05C30.1077 0.00922618 31.5016 0.59564 32.5269 1.63081C33.5522 2.66598 34.1252 4.06544 34.1204 5.52243Z"
            fill="#3C90A8" />
          <path
            d="M21.91 24.0218C20.8211 24.0162 19.7582 23.6876 18.856 23.0777C17.9539 22.4677 17.253 21.6038 16.8422 20.5952C16.4313 19.5867 16.329 18.479 16.5481 17.4122C16.7671 16.3455 17.2978 15.3677 18.0729 14.6028C18.848 13.8378 19.8326 13.32 20.9022 13.115C21.9717 12.91 23.078 13.0269 24.081 13.451C25.0841 13.8751 25.9387 14.5873 26.5368 15.4974C27.1348 16.4075 27.4493 17.4746 27.4406 18.5635C27.4391 19.286 27.2945 20.001 27.0152 20.6673C26.7358 21.3336 26.3272 21.9379 25.813 22.4454C25.2988 22.9529 24.6891 23.3535 24.0192 23.6241C23.3493 23.8946 22.6325 24.0298 21.91 24.0218Z"
            fill="#3C90A8" />
        </svg>

        {{ $t('tabs.Thawani_app') }}
      </button>
      <button v-show="isQRPay" id="tab-scan-qr" role="tab" :aria-selected="selectedTab === 'scan-qr'"
        aria-controls="panel-scan-qr" :class="selectedTab === 'scan-qr' ? 'selectedTab' : 'unselectedTab'"
        @click="selectTab('scan-qr')"
        class="flex-1 font-normal py-2 rounded flex items-center justify-center tabsBtnStyle">
        <svg
          :class="[selectedTab === 'scan-qr' ? 'text-white' : 'text-current', isRtl ? 'order-2 ml-2 mr-0' : 'mr-2 ml-0']"
          class="h-6 w-6" viewBox="0 0 100 101">
          <path
            d="M46.875 22.375V41.125C46.875 42.7826 46.2165 44.3723 45.0444 45.5444C43.8723 46.7165 42.2826 47.375 40.625 47.375H21.875C20.2174 47.375 18.6277 46.7165 17.4556 45.5444C16.2835 44.3723 15.625 42.7826 15.625 41.125V22.375C15.625 20.7174 16.2835 19.1277 17.4556 17.9556C18.6277 16.7835 20.2174 16.125 21.875 16.125H40.625C42.2826 16.125 43.8723 16.7835 45.0444 17.9556C46.2165 19.1277 46.875 20.7174 46.875 22.375ZM40.625 53.625H21.875C20.2174 53.625 18.6277 54.2835 17.4556 55.4556C16.2835 56.6277 15.625 58.2174 15.625 59.875V78.625C15.625 80.2826 16.2835 81.8723 17.4556 83.0444C18.6277 84.2165 20.2174 84.875 21.875 84.875H40.625C42.2826 84.875 43.8723 84.2165 45.0444 83.0444C46.2165 81.8723 46.875 80.2826 46.875 78.625V59.875C46.875 58.2174 46.2165 56.6277 45.0444 55.4556C43.8723 54.2835 42.2826 53.625 40.625 53.625ZM78.125 16.125H59.375C57.7174 16.125 56.1277 16.7835 54.9556 17.9556C53.7835 19.1277 53.125 20.7174 53.125 22.375V41.125C53.125 42.7826 53.7835 44.3723 54.9556 45.5444C56.1277 46.7165 57.7174 47.375 59.375 47.375H78.125C79.7826 47.375 81.3723 46.7165 82.5444 45.5444C83.7165 44.3723 84.375 42.7826 84.375 41.125V22.375C84.375 20.7174 83.7165 19.1277 82.5444 17.9556C81.3723 16.7835 79.7826 16.125 78.125 16.125ZM56.25 72.375C57.0788 72.375 57.8737 72.0458 58.4597 71.4597C59.0458 70.8737 59.375 70.0788 59.375 69.25V56.75C59.375 55.9212 59.0458 55.1263 58.4597 54.5403C57.8737 53.9542 57.0788 53.625 56.25 53.625C55.4212 53.625 54.6263 53.9542 54.0403 54.5403C53.4542 55.1263 53.125 55.9212 53.125 56.75V69.25C53.125 70.0788 53.4542 70.8737 54.0403 71.4597C54.6263 72.0458 55.4212 72.375 56.25 72.375ZM81.25 59.875H71.875V56.75C71.875 55.9212 71.5458 55.1263 70.9597 54.5403C70.3737 53.9542 69.5788 53.625 68.75 53.625C67.9212 53.625 67.1263 53.9542 66.5403 54.5403C65.9542 55.1263 65.625 55.9212 65.625 56.75V78.625H56.25C55.4212 78.625 54.6263 78.9542 54.0403 79.5403C53.4542 80.1263 53.125 80.9212 53.125 81.75C53.125 82.5788 53.4542 83.3737 54.0403 83.9597C54.6263 84.5458 55.4212 84.875 56.25 84.875H68.75C69.5788 84.875 70.3737 84.5458 70.9597 83.9597C71.5458 83.3737 71.875 82.5788 71.875 81.75V66.125H81.25C82.0788 66.125 82.8737 65.7958 83.4597 65.2097C84.0458 64.6237 84.375 63.8288 84.375 63C84.375 62.1712 84.0458 61.3763 83.4597 60.7903C82.8737 60.2042 82.0788 59.875 81.25 59.875ZM81.25 72.375C80.4212 72.375 79.6263 72.7042 79.0403 73.2903C78.4542 73.8763 78.125 74.6712 78.125 75.5V81.75C78.125 82.5788 78.4542 83.3737 79.0403 83.9597C79.6263 84.5458 80.4212 84.875 81.25 84.875C82.0788 84.875 82.8737 84.5458 83.4597 83.9597C84.0458 83.3737 84.375 82.5788 84.375 81.75V75.5C84.375 74.6712 84.0458 73.8763 83.4597 73.2903C82.8737 72.7042 82.0788 72.375 81.25 72.375Z"
            fill="#3C90A8" />
        </svg>
        {{ $t('tabs.Scan_Pay') }}
      </button>
    </div>
    <div id="panel-bank-card" role="tabpanel" aria-labelledby="tab-bank-card" class=" p-0">
      <validation-observer ref="paymentForm">
        <form @submit.prevent="InitiatePayment">
          <div class="mb-6 relative">
            <label for="card-holder" class="block text-gray-700 labelStyle title_margin_bottom"
              style="margin-bottom:1px">{{ $t('tabs.card_holder') }} </label>
            <validation-provider v-slot="{ failed, errors }" :name="$t('tabs.card_holder')"
              rules="required|alpha_spaces|max:120|english_letters">
              <input :disabled="purchaseLoad" id="holder" v-model="cardInformation.NameOnCard" :class="!failed
                ? ''
                : 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red'
                " class="form-input block w-full sm:text-sm sm:leading-5 textFieldStyle"
                :placeholder="$t('home.name_on_card')" />
              <p id="date-error" class=" left-0 text-xs   absolute mt-1 error-msg-text  normal-case"
                :class="{ 'right-0': isRtl, 'left-0': !isRtl }">
                {{ errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="mb-6 relative">
            <label for="card-number" class="block text-gray-700 labelStyle title_margin_bottom"> {{
              $t('tabs.card_number') }}</label>
            <validation-provider v-slot="{ failed, errors }" :name="$t('tabs.card_number')" rules="required|min:13"
              vid="card">
              <div class="relative">
                <input :disabled="purchaseLoad" type="text" name="cc-number" inputmode="numeric"
                  v-model="cardInformation.cardNumber" v-cleave="{
                    creditCard: true,
                    onCreditCardTypeChanged: cardChanged,
                  }" :class="[
                    !failed ? '' : 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red',
                    isRtl ? 'ltr text-right' : ''
                  ]" aria-label="Card number" placeholder="1234  5678  9101  1121"
                  class=" block w-full p-2 border border-gray-300 rounded-md textFieldStyle" style="direction: ltr;" />
                <transition-group class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                  :class="{ 'left-0 pl-3 ': isRtl, 'right-0 pr-3 ': !isRtl }" enter-active-class="duration-150 ease-out"
                  enter-class="opacity-0 scale-95" enter-to-class="opacity-100 scale-100"
                  leave-active-class="duration-100 ease-in" leave-class="opacity-100 scale-100"
                  leave-to-class="opacity-0 scale-95">
                     <img  class="h-5 mx-1" src="@/assets/images/Group.svg" alt="" v-show="cardType === 'maal' ||
                    cardInformation.cardNumber === ''
                    " :key="'maal'"  />
                  <svg v-show="cardType === 'visa' ||
                    cardInformation.cardNumber === ''
                    " :key="'visa'" class="h-9 w-9" clip-rule="evenodd" fill-rule="evenodd" viewBox="0 0 560 400"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="m286.87 176.71c-.228 17.993 16.036 28.034 28.287 34.004 12.588 6.126 16.816 10.054 16.768 15.531-.096 8.384-10.042 12.083-19.35 12.227-16.24.252-25.681-4.384-33.188-7.891l-5.849 27.373c7.531 3.472 21.476 6.499 35.938 6.631 33.944 0 56.152-16.756 56.273-42.736.132-32.971-45.607-34.797-45.295-49.535.108-4.468 4.372-9.237 13.717-10.45 4.624-.612 17.392-1.081 31.866 5.585l5.681-26.484c-7.783-2.835-17.789-5.55-30.244-5.55-31.95 0-54.423 16.984-54.604 41.295m139.44-39.013c-6.198 0-11.423 3.616-13.753 9.165l-48.49 115.777h33.92l6.75-18.654h41.451l3.916 18.654h29.896l-26.089-124.942zm4.744 33.752 9.789 46.916h-26.809zm-185.31-33.752-26.737 124.942h32.322l26.725-124.942zm-47.817 0-33.644 85.04-13.609-72.308c-1.597-8.071-7.903-12.732-14.906-12.732h-54.999l-.769 3.628c11.291 2.45 24.119 6.402 31.89 10.63 4.756 2.582 6.114 4.84 7.675 10.978l25.776 99.706h34.161l52.369-124.942z"
                      fill="#1a1f71" />
                  </svg>
                  <svg v-show="cardType === 'mastercard' ||
                    cardInformation.cardNumber === ''
                    " :key="'mastercard'" class="h-9 w-9" clip-rule="evenodd" fill-rule="evenodd" viewBox="0 0 560 400"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <clipPath id="a">
                      <path clip-rule="evenodd" d="m125.758 80h308.483v240h-308.483z" />
                    </clipPath>
                    <g clip-path="url(#a)">
                      <path
                        d="m428.163 316.746v.616h.575c.108.002.215-.025.309-.078.076-.054.12-.143.115-.236.004-.092-.039-.179-.115-.23-.093-.056-.2-.083-.309-.079h-.575zm.581-.437c.247-.015.491.056.691.201.163.133.253.336.243.546.007.18-.064.355-.195.479-.154.134-.348.215-.552.23l.771.879h-.594l-.709-.873h-.23v.873h-.497v-2.333h1.08zm-.154 3.14c.261.003.519-.05.758-.154.23-.099.439-.241.617-.418.177-.177.319-.386.418-.617.202-.489.202-1.038 0-1.527-.1-.23-.242-.439-.418-.617-.178-.177-.387-.319-.617-.418-.241-.098-.498-.148-.758-.145-.264-.002-.526.047-.771.145-.235.097-.45.239-.631.418-.557.571-.719 1.424-.412 2.16.094.231.234.441.412.617.182.178.396.32.631.418.244.104.506.156.771.154m0-4.473c.678-.001 1.329.265 1.813.74.233.228.418.5.546.801.266.622.266 1.328 0 1.951-.131.298-.316.57-.546.8-.237.227-.512.41-.813.54-.316.134-.656.203-1 .201-.347.002-.691-.066-1.012-.201-.304-.127-.582-.31-.819-.54-.23-.238-.413-.519-.538-.826-.266-.623-.266-1.329 0-1.952.127-.3.313-.572.546-.8.234-.234.512-.417.819-.54.32-.135.665-.203 1.012-.2m-236.183-8.987c0-4.449 2.916-8.105 7.68-8.105 4.553 0 7.626 3.498 7.626 8.105 0 4.608-3.073 8.106-7.626 8.106-4.764 0-7.68-3.656-7.68-8.106m20.496 0v-12.663h-5.505v3.085c-1.746-2.28-4.394-3.709-7.996-3.709-7.095 0-12.663 5.565-12.663 13.294s5.565 13.294 12.663 13.294c3.6 0 6.25-1.432 7.996-3.71v3.074h5.499v-12.665zm186.003 0c0-4.449 2.915-8.105 7.681-8.105 4.558 0 7.626 3.498 7.626 8.105 0 4.608-3.068 8.106-7.626 8.106-4.764 0-7.681-3.656-7.681-8.106m20.502 0v-22.827h-5.51v13.249c-1.746-2.28-4.394-3.709-7.995-3.709-7.096 0-12.664 5.565-12.664 13.294s5.565 13.294 12.664 13.294c3.601 0 6.249-1.432 7.995-3.71v3.074h5.51zm-138.182-8.366c3.547 0 5.826 2.225 6.407 6.141h-13.135c.588-3.656 2.807-6.141 6.729-6.141m.11-4.935c-7.419 0-12.609 5.398-12.609 13.294 0 8.05 5.398 13.294 12.978 13.294 3.812 0 7.305-.952 10.377-3.548l-2.698-4.079c-2.122 1.696-4.824 2.648-7.365 2.648-3.547 0-6.777-1.643-7.571-6.201h18.797c.054-.684.109-1.375.109-2.116-.055-7.892-4.935-13.294-12.021-13.294m66.463 13.294c0-4.45 2.915-8.105 7.679-8.105 4.554 0 7.626 3.498 7.626 8.105s-3.072 8.106-7.626 8.106c-4.764 0-7.681-3.656-7.681-8.106m20.496 0v-12.654h-5.502v3.085c-1.752-2.28-4.394-3.709-7.996-3.709-7.095 0-12.663 5.565-12.663 13.294s5.565 13.294 12.663 13.294c3.602 0 6.244-1.432 7.996-3.71v3.074h5.503v-12.665zm-51.582 0c0 7.68 5.346 13.294 13.506 13.294 3.812 0 6.353-.848 9.1-3.018l-2.644-4.45c-2.067 1.485-4.237 2.28-6.632 2.28-4.395-.054-7.626-3.232-7.626-8.106s3.231-8.05 7.626-8.105c2.389 0 4.559.794 6.632 2.279l2.644-4.449c-2.752-2.171-5.292-3.019-9.1-3.019-8.16 0-13.506 5.613-13.506 13.294m70.967-13.294c-3.176 0-5.244 1.485-6.674 3.71v-3.07h-5.456v25.314h5.511v-14.19c0-4.189 1.8-6.517 5.399-6.517 1.178-.017 2.348.2 3.442.637l1.697-5.188c-1.218-.48-2.807-.691-3.922-.691m-147.554 2.648c-2.648-1.746-6.298-2.648-10.323-2.648-6.414 0-10.543 3.074-10.543 8.104 0 4.127 3.074 6.674 8.735 7.468l2.6.37c3.019.424 4.444 1.219 4.444 2.648 0 1.958-2.005 3.075-5.77 3.075-3.813 0-6.565-1.219-8.42-2.649l-2.587 4.293c3.019 2.224 6.832 3.285 10.961 3.285 7.311 0 11.548-3.443 11.548-8.263 0-4.45-3.335-6.777-8.844-7.571l-2.595-.377c-2.383-.308-4.292-.788-4.292-2.485 0-1.85 1.8-2.964 4.82-2.964 3.231 0 6.359 1.218 7.892 2.17l2.383-4.45zm71.03-2.644c-3.176 0-5.244 1.486-6.668 3.71v-3.079h-5.456v25.314h5.505v-14.19c0-4.189 1.8-6.517 5.399-6.517 1.178-.017 2.348.2 3.442.637l1.697-5.188c-1.218-.48-2.807-.691-3.922-.691m-46.973.635h-9.002v-7.679h-5.565v7.679h-5.134v5.032h5.134v11.548c0 5.873 2.28 9.371 8.792 9.371 2.389 0 5.141-.74 6.887-1.957l-1.59-4.714c-1.643.952-3.443 1.432-4.874 1.432-2.752 0-3.65-1.697-3.65-4.237v-11.439h9.002zm-82.302 25.321v-15.887c0-5.983-3.813-10.009-9.959-10.063-3.232-.054-6.565.952-8.898 4.504-1.746-2.807-4.498-4.504-8.366-4.504-2.704 0-5.346.794-7.415 3.759v-3.13h-5.509v25.314h5.552v-14.036c0-4.394 2.437-6.729 6.201-6.729 3.655 0 5.505 2.383 5.505 6.674v14.088h5.565v-14.036c0-4.394 2.54-6.729 6.194-6.729 3.759 0 5.553 2.383 5.553 6.674v14.088z"
                        fill="#231f20" />
                      <path
                        d="m431.302 234.43v-3.702h-.964l-1.115 2.54-1.109-2.54h-.967v3.702h.684v-2.789l1.043 2.406h.71l1.042-2.412v2.795h.679zm-6.116 0v-3.068h1.234v-.625h-3.153v.625h1.234v3.068z"
                        fill="#f79410" />
                      <path d="m321.733 250.306h-83.423v-149.923h83.425z" fill="#ff5f00" />
                      <path
                        d="m243.599 175.348c0-30.412 14.24-57.503 36.413-74.962-16.781-13.232-37.548-20.418-58.918-20.386-52.654 0-95.336 42.688-95.336 95.348 0 52.659 42.682 95.347 95.336 95.347 21.37.032 42.138-7.154 58.92-20.386-22.172-17.456-36.415-44.548-36.415-74.961"
                        fill="#eb001b" />
                      <path
                        d="m434.28 175.348c0 52.659-42.682 95.347-95.335 95.347-21.373.031-42.143-7.154-58.928-20.386 22.18-17.459 36.42-44.548 36.42-74.961 0-30.414-14.24-57.503-36.42-74.962 16.784-13.232 37.554-20.417 58.926-20.386 52.654 0 95.336 42.688 95.336 95.348"
                        fill="#f79410" />
                    </g>
                  </svg>
                </transition-group>
              </div>
              <p id="date-error" class=" left-0 text-xs mt-1 error-msg-text  normal-case  absolute  "
                :class="{ 'right-0': isRtl, 'left-0': !isRtl }">
                {{ errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="mb-6 flex space-x-4 relative">
            <div class="flex-1 relative">
              <label for="expiry-date" class="block text-gray-700 labelStyle title_margin_bottom">{{
                $t('tabs.expiry_date') }}</label>
              <validation-provider v-slot="{ failed, errors }" name="Date" rules="required|min:6|card_date">
                <input :disabled="purchaseLoad" type="text" inputmode="numeric" autocomplete="cc-exp"
                  v-model="cardInformation.date" v-cleave="{
                    date: true,
                    delimiter: ' / ',
                    datePattern: isRtl ? ['m', 'y'] : ['m', 'y'], // Flip pattern based on isRtl
                  }"
                  :class="[!failed ? '' : 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red', isRtl ? 'ltr text-right' : '']"
                  aria-label="Card expiration date"
                  class="form-input relative block w-full rounded-none rounded-bl-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5 textFieldStyle"
                  :placeholder="isRtl ? 'YY / MM' : 'MM / YY'" />
                <p id="date-error" class=" left-0 text-xs mt-1 error-msg-text normal-case w-full"
                  :class="{ 'left-0': !isRtl }">
                  {{ errors[0] }}
                </p>
              </validation-provider>
            </div>
            <div class="flex-1 relative">
              <label for="cvv" class=" flex items-center justify-between  text-gray-700 ">
                <span :class="{ 'order-2 ml-2': isRtl }" class="labelStyle title_margin_bottom"> {{ $t('tabs.CVV')
                  }}</span>
                <div class="relative flex items-center has-tooltip ">
                  <span
                    class="tooltip rounded-lg shadow-lg p-2 bg-white border border-gray-200 absolute  lg:left-3/4 transform -translate-x-3/4 w-48 "
                    :class="{ 'text-right': isRtl }" style="top:-6rem">
                    <span class="text-sm font-normal ">{{ $t('tabs.CVV_des') }}</span>
                    <span
                      class="tooltip-arrow absolute w-3 h-3 bg-white border-t-0 border-r border-b border-l-0 border-gray-200 transform rotate-45 -bottom-2 arrow-style "></span>
                  </span>
                  <img :class="{ 'order-1': isRtl }" class="h-5 w-5 LabelColor cursor-pointer"
                    src="@/assets/images/info.svg" alt="info" />
                </div>
              </label>
              <validation-provider v-slot="{ failed, errors }" :name="$t('tabs.CVV_placeholder')"
                rules="required|min:3">
                <input :disabled="purchaseLoad" v-model="cardInformation.cvv" type="password" inputmode="numeric"
                  v-cleave="{
                    blocks: [4],
                    numericOnly: true,
                  }" :class="!failed
                    ? ''
                    : 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red'
                    " aria-label="Card CVV" autocomplete="off"
                  class="form-input relative block w-full rounded-none rounded-br-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5 textFieldStyle"
                  :placeholder="$t('tabs.CVV')" />
                <p id="cvv-error" class="absolute right-0 text-xs mt-1 error-msg-text normal-case text-start  "
                  :class="{ 'right-0': isRtl, 'left-0': !isRtl }">
                  {{ errors[0] }}
                </p>
              </validation-provider>
            </div>
          </div>
          <!-- <div class="mb-5 flex items-center relative" v-show="isCheckboxSeen" v-if="isSaveCardAllowed"
            :class="{ 'justify-end': isRtl }">
            <div :class="{ 'order-2 mt-1 flex': isRtl, 'mr-2 mt-1 flex': !isRtl }"
              style="display: flex;place-items: center;">
              <input type="checkbox" id="SaveCardDetails " :disabled="isAutoSaveCard === true"
                v-model="cardInformation.saveCard" :class="{ 'order-2 ml-2': isRtl }" />
              <label for="SaveCardDetails" class="flex cursor-pointer">
                <div :class="{ ' order-2': isRtl, 'mr-2': !isRtl }">
                  <div :class="toggleSaveCardDetails">
                    <svg v-show="isChecked" class="w-4 h-4" fill="none" stroke="white" viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7">
                      </path>
                    </svg>
                  </div>
                </div>
                <label class="block text-gray-700 font-bold labelStyle" style="margin-bottom: -1px;">
                  {{ $t('tabs.save_card_details') }}
                </label>
              </label>
            </div>
          </div> -->
          <div class="flex items-start mt-4 lg:mt- mb-6 " v-show="isCheckboxSeen" v-if="isSaveCardAllowed"
            :class="{ 'order-2 mt-1 flex justify-end': isRtl, 'mr-2 mt-1 flex justify-start': !isRtl }">
            <div class="" :class="{ 'order-2': isRtl, 'order-1': !isRtl, 'ml-2 mr-0': isRtl, 'mr-2 ml-0': !isRtl }">
              <input type="checkbox" id="AutoSavecheckbox" class="sr-only" :disabled="isAutoSaveCard === true"
                v-model="cardInformation.saveCard" @change="toggleSaveCardDetails">
              <label for="AutoSavecheckbox"
                :class="{ 'SaveCardDetailsCheck': isAutoSaveCard, 'custom-checkbox-label': !isAutoSaveCard }">
                <svg v-show="isChecked" class="w-4 h-4" fill="none" stroke="white" viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
              </label>
            </div>
            <label class="block text-gray-700 labelStyle"
              :class="{ 'order-1': isRtl, 'order-2': !isRtl, 'ml-2 mr-0': isRtl, 'mr-2 ml-0': !isRtl }">
              {{ $t('tabs.save_card_details') }}
            </label>
          </div>

          <div class="mb-6 relative" v-show="cardInformation.saveCard">
            <label for="card-holder" class="block text-gray-700 font-bold labelStyle">{{ $t('home.nickname') }}</label>
            <validation-provider v-slot="{ failed, errors }"
              :rules="cardInformation.saveCard ? 'required|alpha_spaces|max:40|english_letters' : ''"
              :name="$t('home.nickname')">
              <input :disabled="purchaseLoad" id="nickname" v-model="cardInformation.nickname" :class="!failed
                ? ''
                : 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red'
                " class="form-input block w-full sm:text-sm sm:leading-5 textFieldStyle" placeholder="" />
              <p id="nickname-error" class="absolute  text-xs mt-1 error-msg-text normal-case"
                :class="{ 'right-0': isRtl, 'left-0': !isRtl }">
                {{ errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="my-5  warning-style" v-show="isCybersourceDown">
            <img class="w-25 h-8 block" src="@/assets/images/Icon-warning.svg" alt="">
            <p :class="{ 'text-right': isRtl, 'text-left': !isRtl }">{{ $t('home.credit_cards_issues') }}</p>
          </div>
          <div class="warning-style my-6" v-show="isOmanNetDown">
            <img class="w-25 h-8 block" src="@/assets/images/Icon-warning.svg" alt="">
            <p :class="{ 'text-right': isRtl, 'text-left': !isRtl }">{{ $t('home.debit_cards_issues') }}</p>
          </div>
          <div class="error-style" v-show="is3DSecureError">
            <p :class="{ 'text-right': isRtl, 'text-left': !isRtl }">{{ $t('validation.card_declined') }}</p>
          </div>
          <button :disabled="purchaseLoad || isSuccess" :class="!purchaseLoad ? '' : 'bg-gray-500'" type="submit"
            class="w-full text-white font-bold py-3 mt-5 rounded payBtn labelBtn">
            <span v-show="!purchaseLoad && !isSuccess">
              {{ $t('comman.pay') }}
              <span class="currency-inline-btn">
                <img src="@/assets/images/omani_rial.svg" alt="OMR" class="currency-icon-btn">
                <span>{{ formatAmount(totalAmount / 1000) }}</span>
              </span>
            </span>
            <svg v-show="purchaseLoad" :class="`animate-spin h-5 w-5 text-white ${isRtl ? 'ml-3 -mr-1' : '-ml-1 mr-3'}`"
              fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                fill="currentColor"></path>
            </svg>

            <span v-show="purchaseLoad"> {{ $t('comman.processing') }} </span>
            <svg v-show="isSuccess" class="-ml-1 mr-3 h-5 w-5 text-white fill-current" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
            </svg>
            <span v-show="isSuccess"> {{ $t('comman.successful') }} </span>
          </button>
          <button type="button" class="mt-3 w-full text-center font-bold LabelColor labelBtn"
            :class="purchaseLoad ? 'text-gray-500 pointer-events-none' : 'text-red-500'" @click="CancelModal">{{
              $t('comman.cancel') }}</button>
        </form>
      </validation-observer>
    </div>
    <div id="panel-deep-link" role="tabpanel" aria-labelledby="deep-link" class="hidden p-4">
      <div class="flex-1 relative">
        <label for="cvv" class="block text-gray-700 font-medium flex items-center justify-between mb-4"
          :class="{ 'flex-row-reverse': isRtl }">
          <h3 :class="{ 'order-2': isRtl, 'order-1': !isRtl }" class="labelStyle">{{ $t('tabs.Instructions') }}</h3>
          <button :class="{ 'order-1': isRtl, 'order-2': !isRtl }">
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"
              @click="isThawaniPayModalOpen = true" class="pointer-cursor">
              <path
                d="M10 15.5C10.2833 15.5 10.521 15.404 10.713 15.212C10.905 15.02 11.0007 14.7827 11 14.5V10.5C11 10.2167 10.904 9.97933 10.712 9.788C10.52 9.59667 10.2827 9.50067 10 9.5C9.71733 9.49933 9.48 9.59533 9.288 9.788C9.096 9.98067 9 10.218 9 10.5V14.5C9 14.7833 9.096 15.021 9.288 15.213C9.48 15.405 9.71733 15.5007 10 15.5ZM10 7.5C10.2833 7.5 10.521 7.404 10.713 7.212C10.905 7.02 11.0007 6.78267 11 6.5C10.9993 6.21733 10.9033 5.98 10.712 5.788C10.5207 5.596 10.2833 5.5 10 5.5C9.71667 5.5 9.47933 5.596 9.288 5.788C9.09667 5.98 9.00067 6.21733 9 6.5C8.99933 6.78267 9.09533 7.02033 9.288 7.213C9.48067 7.40567 9.718 7.50133 10 7.5ZM10 20.5C8.61667 20.5 7.31667 20.2373 6.1 19.712C4.88334 19.1867 3.825 18.4743 2.925 17.575C2.025 16.6757 1.31267 15.6173 0.788001 14.4C0.263335 13.1827 0.000667933 11.8827 1.26582e-06 10.5C-0.000665401 9.11733 0.262001 7.81733 0.788001 6.6C1.314 5.38267 2.02633 4.32433 2.925 3.425C3.82367 2.52567 4.882 1.81333 6.1 1.288C7.318 0.762667 8.618 0.5 10 0.5C11.382 0.5 12.682 0.762667 13.9 1.288C15.118 1.81333 16.1763 2.52567 17.075 3.425C17.9737 4.32433 18.6863 5.38267 19.213 6.6C19.7397 7.81733 20.002 9.11733 20 10.5C19.998 11.8827 19.7353 13.1827 19.212 14.4C18.6887 15.6173 17.9763 16.6757 17.075 17.575C16.1737 18.4743 15.1153 19.187 13.9 19.713C12.6847 20.239 11.3847 20.5013 10 20.5ZM10 18.5C12.2333 18.5 14.125 17.725 15.675 16.175C17.225 14.625 18 12.7333 18 10.5C18 8.26667 17.225 6.375 15.675 4.825C14.125 3.275 12.2333 2.5 10 2.5C7.76667 2.5 5.875 3.275 4.325 4.825C2.775 6.375 2 8.26667 2 10.5C2 12.7333 2.775 14.625 4.325 16.175C5.875 17.725 7.76667 18.5 10 18.5Z"
                fill="#6EB74C" />
            </svg>
          </button>

        </label>
      </div>
      <ul class="list-none space-y-2 mb-4">
        <li class="flex items-start text-xs lg:text-sm">
          {{ $t('tabs.clicking_Pay_Thawani_app') }}
        </li>

        <li class="flex items-start text-xs lg:text-sm" :class="{ 'justify-end': isRtl }">
          <span> {{ $t('tabs.Download_Thawani_app') }} <a href="https://download.thawani.om" target="_blank"
              class="LabelColor underline text-xs lg:text-sm">{{ $t('tabs.from_here') }}</a>.</span>
        </li>
      </ul>
      <div class="flex items-start mb-4">
        <div class=" mr-2 mt-1" :class="{ 'order-2': isRtl, 'order-1': !isRtl, 'ml-2': isRtl, 'mr-2': !isRtl }">
          <input type="checkbox" id="custom-checkbox" class="hidden" @change="proceedPaymentByDeepLinking">
          <label for="custom-checkbox" class="custom-checkbox-label">
            <svg class="hidden w-4 h-4" fill="none" stroke="white" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7">
              </path>
            </svg>
          </label>
        </div>
        <label class="text-gray-700 text-xs lg:text-sm"
          :class="{ 'order-1': isRtl, 'order-2': !isRtl, 'ml-2': isRtl, 'mr-2': !isRtl }">
          {{ $t('tabs.Thawani_app_confirm') }}</label>
      </div>
      <button :disabled="!isTermsAccepted" :class="isTermsAccepted ? 'payBtn' : 'bg-gray-200 cursor-not-allowed'"
        class="w-full text-white font-bold py-3 rounded-md mt-4 text-xs lg:text-sm " @click="OpenThawaniApp">
        {{ $t('tabs.Pay_via_Thawani_app') }}
      </button>
      <div class="text-sm mt-2">
        <p class="text-xs "> {{ $t('tabs.paid_already') }} <a @click="refreshSession()"
            class="LabelColor underline cursor-pointer">
            {{ $t('tabs.refresh_page') }}</a>.
        </p>
      </div>
    </div>
    <div id="panel-scan-qr" role="tabpanel" aria-labelledby="tab-scan-qr" class="hidden p-4">
      <div class="flex-1 relative">
        <label for="cvv" class="block text-gray-700 font-medium flex items-center justify-between mb-4"
          :class="{ 'flex-row-reverse': isRtl }">
          <h3 :class="{ 'order-2': isRtl, 'order-1': !isRtl }" class="labelStyle">{{ $t('tabs.Instructions') }}</h3>

          <button :class="{ 'order-1': isRtl, 'order-2': !isRtl }">
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"
              @click="isScanQRModalOpen = true" class="pointer-cursor">
              <path
                d="M10 15.5C10.2833 15.5 10.521 15.404 10.713 15.212C10.905 15.02 11.0007 14.7827 11 14.5V10.5C11 10.2167 10.904 9.97933 10.712 9.788C10.52 9.59667 10.2827 9.50067 10 9.5C9.71733 9.49933 9.48 9.59533 9.288 9.788C9.096 9.98067 9 10.218 9 10.5V14.5C9 14.7833 9.096 15.021 9.288 15.213C9.48 15.405 9.71733 15.5007 10 15.5ZM10 7.5C10.2833 7.5 10.521 7.404 10.713 7.212C10.905 7.02 11.0007 6.78267 11 6.5C10.9993 6.21733 10.9033 5.98 10.712 5.788C10.5207 5.596 10.2833 5.5 10 5.5C9.71667 5.5 9.47933 5.596 9.288 5.788C9.09667 5.98 9.00067 6.21733 9 6.5C8.99933 6.78267 9.09533 7.02033 9.288 7.213C9.48067 7.40567 9.718 7.50133 10 7.5ZM10 20.5C8.61667 20.5 7.31667 20.2373 6.1 19.712C4.88334 19.1867 3.825 18.4743 2.925 17.575C2.025 16.6757 1.31267 15.6173 0.788001 14.4C0.263335 13.1827 0.000667933 11.8827 1.26582e-06 10.5C-0.000665401 9.11733 0.262001 7.81733 0.788001 6.6C1.314 5.38267 2.02633 4.32433 2.925 3.425C3.82367 2.52567 4.882 1.81333 6.1 1.288C7.318 0.762667 8.618 0.5 10 0.5C11.382 0.5 12.682 0.762667 13.9 1.288C15.118 1.81333 16.1763 2.52567 17.075 3.425C17.9737 4.32433 18.6863 5.38267 19.213 6.6C19.7397 7.81733 20.002 9.11733 20 10.5C19.998 11.8827 19.7353 13.1827 19.212 14.4C18.6887 15.6173 17.9763 16.6757 17.075 17.575C16.1737 18.4743 15.1153 19.187 13.9 19.713C12.6847 20.239 11.3847 20.5013 10 20.5ZM10 18.5C12.2333 18.5 14.125 17.725 15.675 16.175C17.225 14.625 18 12.7333 18 10.5C18 8.26667 17.225 6.375 15.675 4.825C14.125 3.275 12.2333 2.5 10 2.5C7.76667 2.5 5.875 3.275 4.325 4.825C2.775 6.375 2 8.26667 2 10.5C2 12.7333 2.775 14.625 4.325 16.175C5.875 17.725 7.76667 18.5 10 18.5Z"
                fill="#6EB74C" />
            </svg>
          </button>
        </label>
      </div>
      <ul class="list-none space-y-2 mb-4">
        <li class="flex items-start text-xs lg:text-sm"
          :class="{ 'flex-row-reverse justify-end gap-3': isRtl, 'flex-row gap-3': !isRtl }">
          <svg :class="{ 'order-2': isRtl, 'order-1': !isRtl }" width="24" height="24" viewBox="0 0 16 16" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="8" fill="#EFEFEF" />
            <path
              d="M8 13C7.30833 13 6.65833 12.8688 6.05 12.6062C5.44167 12.3438 4.9125 11.9875 4.4625 11.5375C4.0125 11.0875 3.65625 10.5583 3.39375 9.95C3.13125 9.34167 3 8.69167 3 8C3 7.30833 3.13125 6.65833 3.39375 6.05C3.65625 5.44167 4.0125 4.9125 4.4625 4.4625C4.9125 4.0125 5.44167 3.65625 6.05 3.39375C6.65833 3.13125 7.30833 3 8 3C8.4 3 8.78958 3.04583 9.16875 3.1375C9.54792 3.22917 9.9125 3.3625 10.2625 3.5375C10.3875 3.60417 10.4688 3.70417 10.5062 3.8375C10.5438 3.97083 10.5208 4.09583 10.4375 4.2125C10.3542 4.32917 10.2438 4.40417 10.1063 4.4375C9.96875 4.47083 9.83333 4.45417 9.7 4.3875C9.43333 4.2625 9.15625 4.16667 8.86875 4.1C8.58125 4.03333 8.29167 4 8 4C6.89167 4 5.94792 4.38958 5.16875 5.16875C4.38958 5.94792 4 6.89167 4 8C4 9.10833 4.38958 10.0521 5.16875 10.8313C5.94792 11.6104 6.89167 12 8 12C9.10833 12 10.0521 11.6104 10.8313 10.8313C11.6104 10.0521 12 9.10833 12 8C12 7.93333 11.9979 7.86875 11.9938 7.80625C11.9896 7.74375 11.9833 7.67917 11.975 7.6125C11.9583 7.47083 11.9854 7.33542 12.0563 7.20625C12.1271 7.07708 12.2333 6.99167 12.375 6.95C12.5083 6.90833 12.6333 6.92083 12.75 6.9875C12.8667 7.05417 12.9333 7.15417 12.95 7.2875C12.9667 7.40417 12.9792 7.52083 12.9875 7.6375C12.9958 7.75417 13 7.875 13 8C13 8.69167 12.8688 9.34167 12.6062 9.95C12.3438 10.5583 11.9875 11.0875 11.5375 11.5375C11.0875 11.9875 10.5583 12.3438 9.95 12.6062C9.34167 12.8688 8.69167 13 8 13ZM7.3 8.9L11.95 4.2375C12.0417 4.14583 12.1562 4.09792 12.2937 4.09375C12.4313 4.08958 12.55 4.1375 12.65 4.2375C12.7417 4.32917 12.7875 4.44583 12.7875 4.5875C12.7875 4.72917 12.7417 4.84583 12.65 4.9375L7.65 9.95C7.55 10.05 7.43333 10.1 7.3 10.1C7.16667 10.1 7.05 10.05 6.95 9.95L5.525 8.525C5.43333 8.43333 5.3875 8.31667 5.3875 8.175C5.3875 8.03333 5.43333 7.91667 5.525 7.825C5.61667 7.73333 5.73333 7.6875 5.875 7.6875C6.01667 7.6875 6.13333 7.73333 6.225 7.825L7.3 8.9Z"
              fill="#08849D" />
          </svg>
          <span :class="{ 'order-1': isRtl, 'order-2': !isRtl, 'ml-2': isRtl, 'mr-2': !isRtl }">{{
            $t('tabs.Agree_terms_conditions') }}</span>
        </li>
        <li class="flex items-start text-xs lg:text-sm"
          :class="{ 'flex-row-reverse justify-end gap-3': isRtl, 'flex-row gap-3': !isRtl }">
          <svg :class="{ 'order-2': isRtl, 'order-1': !isRtl }" width="24" height="24" viewBox="0 0 16 16">
            <circle cx="8" cy="8" r="8" fill="#EFEFEF" />
            <path
              d="M4.5 7.5H6.5C7.05 7.5 7.5 7.05 7.5 6.5V4.5C7.5 3.95 7.05 3.5 6.5 3.5H4.5C3.95 3.5 3.5 3.95 3.5 4.5V6.5C3.5 7.05 3.95 7.5 4.5 7.5ZM4.5 4.5H6.5V6.5H4.5V4.5Z"
              fill="#08849D" />
            <path
              d="M4.5 12.5H6.5C7.05 12.5 7.5 12.05 7.5 11.5V9.5C7.5 8.95 7.05 8.5 6.5 8.5H4.5C3.95 8.5 3.5 8.95 3.5 9.5V11.5C3.5 12.05 3.95 12.5 4.5 12.5ZM4.5 9.5H6.5V11.5H4.5V9.5Z"
              fill="#08849D" />
            <path
              d="M8.5 4.5V6.5C8.5 7.05 8.95 7.5 9.5 7.5H11.5C12.05 7.5 12.5 7.05 12.5 6.5V4.5C12.5 3.95 12.05 3.5 11.5 3.5H9.5C8.95 3.5 8.5 3.95 8.5 4.5ZM11.5 6.5H9.5V4.5H11.5V6.5Z"
              fill="#08849D" />
            <path
              d="M12.5 12.25V11.75C12.5 11.61 12.39 11.5 12.25 11.5H11.75C11.61 11.5 11.5 11.61 11.5 11.75V12.25C11.5 12.39 11.61 12.5 11.75 12.5H12.25C12.39 12.5 12.5 12.39 12.5 12.25Z"
              fill="#08849D" />
            <path
              d="M8.5 8.75V9.25C8.5 9.39 8.61 9.5 8.75 9.5H9.25C9.39 9.5 9.5 9.39 9.5 9.25V8.75C9.5 8.61 9.39 8.5 9.25 8.5H8.75C8.61 8.5 8.5 8.61 8.5 8.75Z"
              fill="#08849D" />
            <path
              d="M10.25 9.5H9.75C9.61 9.5 9.5 9.61 9.5 9.75V10.25C9.5 10.39 9.61 10.5 9.75 10.5H10.25C10.39 10.5 10.5 10.39 10.5 10.25V9.75C10.5 9.61 10.39 9.5 10.25 9.5Z"
              fill="#08849D" />
            <path
              d="M8.5 10.75V11.25C8.5 11.39 8.61 11.5 8.75 11.5H9.25C9.39 11.5 9.5 11.39 9.5 11.25V10.75C9.5 10.61 9.39 10.5 9.25 10.5H8.75C8.61 10.5 8.5 10.61 8.5 10.75Z"
              fill="#08849D" />
            <path
              d="M9.75 12.5H10.25C10.39 12.5 10.5 12.39 10.5 12.25V11.75C10.5 11.61 10.39 11.5 10.25 11.5H9.75C9.61 11.5 9.5 11.61 9.5 11.75V12.25C9.5 12.39 9.61 12.5 9.75 12.5Z"
              fill="#08849D" />
            <path
              d="M10.75 11.5H11.25C11.39 11.5 11.5 11.39 11.5 11.25V10.75C11.5 10.61 11.39 10.5 11.25 10.5H10.75C10.61 10.5 10.5 10.61 10.5 10.75V11.25C10.5 11.39 10.61 11.5 10.75 11.5Z"
              fill="#08849D" />
            <path
              d="M11.25 8.5H10.75C10.61 8.5 10.5 8.61 10.5 8.75V9.25C10.5 9.39 10.61 9.5 10.75 9.5H11.25C11.39 9.5 11.5 9.39 11.5 9.25V8.75C11.5 8.61 11.39 8.5 11.25 8.5Z"
              fill="#08849D" />
            <path
              d="M11.75 10.5H12.25C12.39 10.5 12.5 10.39 12.5 10.25V9.75C12.5 9.61 12.39 9.5 12.25 9.5H11.75C11.61 9.5 11.5 9.61 11.5 9.75V10.25C11.5 10.39 11.61 10.5 11.75 10.5Z"
              fill="#08849D" />
          </svg>
          <span :class="{ 'order-1': isRtl, 'order-2': !isRtl, 'ml-2': isRtl, 'mr-2': !isRtl }">
            {{ $t('tabs.generate_QR_code') }}</span>
        </li>
        <li class="flex items-start text-xs lg:text-sm"
          :class="{ 'flex-row-reverse gap-3 justify-end': isRtl, 'flex-row gap-3': !isRtl }">
          <svg :class="{ 'order-2': isRtl, 'order-1': !isRtl }" width="46" height="24" viewBox="0 0 16 16">
            <circle cx="8" cy="8" r="8" fill="#EFEFEF" />
            <path
              d="M5.63632 13.3337C5.36966 13.3337 5.14137 13.2387 4.95147 13.0488C4.76158 12.8589 4.66663 12.6306 4.66663 12.364V3.63669C4.66663 3.37002 4.76158 3.14174 4.95147 2.95184C5.14137 2.76194 5.36966 2.66699 5.63632 2.66699H10.4848C10.7515 2.66699 10.9798 2.76194 11.1697 2.95184C11.3596 3.14174 11.4545 3.37002 11.4545 3.63669V12.364C11.4545 12.6306 11.3596 12.8589 11.1697 13.0488C10.9798 13.2387 10.7515 13.3337 10.4848 13.3337H5.63632ZM5.63632 10.9094V12.364H10.4848V10.9094H5.63632ZM8.06057 12.1215C8.19794 12.1215 8.31309 12.0751 8.40602 11.9821C8.49895 11.8892 8.54541 11.7741 8.54541 11.6367C8.54541 11.4993 8.49895 11.3842 8.40602 11.2912C8.31309 11.1983 8.19794 11.1518 8.06057 11.1518C7.92319 11.1518 7.80804 11.1983 7.71511 11.2912C7.62218 11.3842 7.57572 11.4993 7.57572 11.6367C7.57572 11.7741 7.62218 11.8892 7.71511 11.9821C7.80804 12.0751 7.92319 12.1215 8.06057 12.1215ZM5.63632 9.93972H10.4848V5.09123H5.63632V9.93972ZM5.63632 4.12154H10.4848V3.63669H5.63632V4.12154Z"
              fill="#3C90A8" />
          </svg>
          <span :class="{ 'order-1': isRtl, 'order-2': !isRtl, 'ml-2': isRtl, 'mr-2': !isRtl }">
            {{ $t('tabs.Download_screenshot_QR') }}</span>
        </li>
      </ul>
      <div class="flex items-center mb-4" :class="{ 'justify-end': isRtl }">
        <input type="checkbox" id="acceptTerms" class="hidden" v-model="isChecked" />
        <label for="acceptTerms" class="flex  cursor-pointer">
          <div class="mr-2 " :class="{ 'order-2 mx-2': isRtl }" style="margin-top: 2px;">
            <div :class="checkboxClasses">
              <svg v-show="isChecked" class="w-4 h-4" fill="none" stroke="white" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7">
                </path>
              </svg>
            </div>
          </div>
          <span class="text-gray-600 text-xs lg:text-sm">{{ $t('tabs.agree_terms_conditions_2') }} <a href="#"
              class="LabelColor  underline">{{ $t('tabs.terms_conditions') }}</a>.</span>
        </label>
      </div>

      <!-- QR Code and Download Button -->
      <div :class="QRAreaClasses" style="box-sizing: border-box;margin: 0;padding: 0;">
        <div v-show="!isChecked" style="width: 100%;position: absolute;height: 100%;">
          <svg width="860" height="761" viewBox="0 0 860 761" fill="none" xmlns="http://www.w3.org/2000/svg"
            style="width: 20%;margin: auto;height: 100%;">
            <path
              d="M74.1511 333.317C94.601 333.317 115.081 333.829 135.516 333.106C145.952 332.729 150.619 336.646 150.74 346.664C151.835 403.167 171.494 457.749 206.697 502.029C248.5 557.684 309.834 595.537 378.422 608.011C438.502 620.718 501.147 612.019 555.462 583.425C594.859 564.635 629.14 536.659 655.408 501.862C681.675 467.066 699.157 426.472 706.374 383.513C709.044 369.788 711.005 355.935 712.249 342.009C712.884 333.693 715.497 330.138 724.09 330.168C765.514 330.389 806.932 330.389 848.345 330.168C857.029 330.168 859.672 333.874 859.989 342.145C860.182 366.296 857.736 390.397 852.695 414.02C839.639 482.426 810.047 546.621 766.485 601.036C732.206 644.088 689.569 679.796 641.128 706.024C593.837 732.65 541.873 750.001 488.041 757.139C412.722 767.182 336.08 757.14 265.917 728.034C204.512 702.887 149.849 663.773 106.291 613.811C65.6336 568.01 35.6551 513.793 18.5107 455.057C9.61565 420.228 3.55464 384.741 0.386754 348.939C-0.942334 338.589 0.56799 332.006 14.3422 332.955C34.1879 334.341 54.1997 333.317 74.1511 333.317Z"
              fill="#72BA4F" />
            <path
              d="M408.587 280.578C408.811 292.013 406.709 303.375 402.406 313.976C398.104 324.577 391.691 334.198 383.555 342.257C375.419 350.316 365.729 356.646 355.071 360.863C344.413 365.081 333.009 367.099 321.546 366.795C310.471 366.849 299.493 364.722 289.243 360.536C278.993 356.35 269.672 350.188 261.813 342.403C253.955 334.618 247.714 325.362 243.448 315.167C239.182 304.971 236.975 294.037 236.953 282.989C236.555 271.558 238.502 260.166 242.674 249.511C246.846 238.857 253.156 229.165 261.217 221.029C269.277 212.893 278.918 206.485 289.549 202.197C300.18 197.91 311.577 195.833 323.042 196.094C334.24 195.967 345.352 198.058 355.733 202.248C366.115 206.438 375.558 212.643 383.516 220.503C391.475 228.362 397.789 237.72 402.092 248.032C406.396 258.345 408.603 269.408 408.587 280.578Z"
              fill="#72BA4F" />
            <path
              d="M424.81 0.458862C470.935 -5.08504 512.409 40.5467 510.596 86.4798C510.205 97.8259 507.551 108.981 502.789 119.292C498.028 129.604 491.254 138.866 482.864 146.538C474.474 154.209 464.636 160.136 453.924 163.973C443.212 167.81 431.841 169.48 420.475 168.885C398.468 168.01 377.653 158.676 362.389 142.839C347.125 127.001 338.595 105.888 338.585 83.9187C338.149 72.6235 340.102 61.3632 344.316 50.8701C348.53 40.377 354.91 30.8859 363.043 23.014C371.176 15.1421 380.878 9.06564 391.52 5.17967C402.161 1.2937 413.504 -0.314764 424.81 0.458862Z"
              fill="#72BA4F" />
            <path
              d="M629.634 281.87C633.561 324.067 591.922 367.921 544.497 366.761C532.696 366.668 521.041 364.14 510.267 359.336C499.492 354.532 489.831 347.556 481.891 338.847C473.951 330.137 467.904 319.883 464.131 308.729C460.357 297.575 458.939 285.763 459.964 274.036C461.928 252.761 471.742 232.971 487.503 218.502C503.264 204.034 523.849 195.918 545.268 195.728C556.563 195.558 567.776 197.685 578.22 201.98C588.665 206.274 598.123 212.646 606.018 220.707C613.912 228.768 620.078 238.348 624.138 248.863C628.198 259.379 630.069 270.609 629.634 281.87Z"
              fill="#72BA4F" />
          </svg>
        </div>

        <p class="text-gray-500 mb-3 text-xs lg:text-sm my-2">{{ $t('tabs.Scan_to_pay') }} </p>
        <div class="inline-block bg-gray-200 p-2  w-fit m-auto" id="qrCodeArea">
          <div class="spin-loading-qr" v-show="!qrCodeString">
            <div style="border-top-color:transparent"
              class="w-11 h-11 border-4 border-green border-solid rounded-full animate-spin"></div>
          </div>
          <canvas ref="qrcodeCanvas" class=" w-fit"></canvas>

        </div>
        <!-- <button @click="downloadQR" class="bg-green-500 text-white py-2 px-4 rounded-md mb-4">Generate
                    QR</button> -->
      </div>

      <button :class="btnClasses" @click="downloadPDF">

        <svg width="25" height="25" viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 mr-2">
          <path
            d="M12.5 16.075C12.3667 16.075 12.2417 16.0542 12.125 16.0125C12.0083 15.9708 11.9 15.9 11.8 15.8L8.2 12.2C8 12 7.90417 11.7667 7.9125 11.5C7.92083 11.2333 8.01667 11 8.2 10.8C8.4 10.6 8.6375 10.4958 8.9125 10.4875C9.1875 10.4792 9.425 10.575 9.625 10.775L11.5 12.65V5.5C11.5 5.21667 11.5958 4.97917 11.7875 4.7875C11.9792 4.59583 12.2167 4.5 12.5 4.5C12.7833 4.5 13.0208 4.59583 13.2125 4.7875C13.4042 4.97917 13.5 5.21667 13.5 5.5V12.65L15.375 10.775C15.575 10.575 15.8125 10.4792 16.0875 10.4875C16.3625 10.4958 16.6 10.6 16.8 10.8C16.9833 11 17.0792 11.2333 17.0875 11.5C17.0958 11.7667 17 12 16.8 12.2L13.2 15.8C13.1 15.9 12.9917 15.9708 12.875 16.0125C12.7583 16.0542 12.6333 16.075 12.5 16.075ZM6.5 20.5C5.95 20.5 5.47917 20.3042 5.0875 19.9125C4.69583 19.5208 4.5 19.05 4.5 18.5V16.5C4.5 16.2167 4.59583 15.9792 4.7875 15.7875C4.97917 15.5958 5.21667 15.5 5.5 15.5C5.78333 15.5 6.02083 15.5958 6.2125 15.7875C6.40417 15.9792 6.5 16.2167 6.5 16.5V18.5H18.5V16.5C18.5 16.2167 18.5958 15.9792 18.7875 15.7875C18.9792 15.5958 19.2167 15.5 19.5 15.5C19.7833 15.5 20.0208 15.5958 20.2125 15.7875C20.4042 15.9792 20.5 16.2167 20.5 16.5V18.5C20.5 19.05 20.3042 19.5208 19.9125 19.9125C19.5208 20.3042 19.05 20.5 18.5 20.5H6.5Z"
            fill="currentColor" />
        </svg>

        {{ $t('tabs.Download_QR') }}
      </button>
      <div class="text-xs ">
        <p> {{ $t('tabs.paid_already') }} <a @click="refreshSession()" class="LabelColor underline cursor-pointer">
            {{ $t('tabs.refresh_page') }}</a>.
        </p>
      </div>
    </div>

    <div v-if="showCancelModal" class="fixed z-50 inset-0 bg-gray-100 bg-opacity-25 overflow-y-auto h-full w-full"
      id="my-modal">
      <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
        <div class="fixed z-10 inset-0 overflow-y-auto">
          <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <div
              class="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
              <!-- X Close Button -->
              <!-- <button @click="CancelModal"
                class="absolute top-2 right-2 text-gray-400 hover:text-gray-600 focus:outline-none">
                <span class="sr-only">Close</span>
                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button> -->
              <div class="sm:block absolute top-0 right-0 pt-4 pr-4">
                <button class="" @click="CancelModal">
                  <svg width="24" height="24" viewBox="0 0 32 32" fill="none">
                    <path
                      d="M24.4 7.61329C23.88 7.09329 23.04 7.09329 22.52 7.61329L16 14.12L9.47996 7.59996C8.95996 7.07996 8.11996 7.07996 7.59996 7.59996C7.07996 8.11996 7.07996 8.95996 7.59996 9.47996L14.12 16L7.59996 22.52C7.07996 23.04 7.07996 23.88 7.59996 24.4C8.11996 24.92 8.95996 24.92 9.47996 24.4L16 17.88L22.52 24.4C23.04 24.92 23.88 24.92 24.4 24.4C24.92 23.88 24.92 23.04 24.4 22.52L17.88 16L24.4 9.47996C24.9066 8.97329 24.9066 8.11996 24.4 7.61329Z"
                      fill="#616163" />
                  </svg>
                </button>
              </div>

              <!-- Modal Content -->
              <div class="mt-3 text-center sm:mt-5">
                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                  {{ $t('tabs.cancel_confirmation') }}
                </h3>
                <div class="mt-2">
                  <p class="text-sm text-gray-500">
                    {{ $t('tabs.about_cancel_confirmation') }}
                  </p>
                </div>
              </div>

              <!-- Proceed Button -->
              <div class="mt-5 sm:mt-6 flex justify-center">
                <button type="button"
                  class="w-full sm:w-auto inline-flex justify-center items-center rounded-md border border-transparent shadow-sm px-6 py-2 payBtn text-base font-medium text-white primary-btn sm:text-sm"
                  :href="cancelUrl" :disabled="purchaseLoad" @click.prevent="cancelSession">
                  <svg v-show="isCancel" class="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      fill="currentColor"></path>
                  </svg>
                  <span v-show="!isCancel">{{ $t('comman.sure') }}</span>
                  <span v-show="isCancel" class="mr-3">{{ $t('comman.sure') }}</span>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <transition enter-active-class="ease-out duration-300" enter-class="opacity-0" enter-to-class="opacity-100"
      leave-active-class="ease-in duration-200" leave-class="opacity-100" leave-to-class="opacity-0">
      <div v-show="show3dSecure" class="fixed z-50 inset-0 overflow-y-auto">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
          <transition enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100" leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div aria-labelledby="modal-headline" aria-modal="true"
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl overflow-hidden transform transition-all sm:my-8 sm:align-middle w-full sm:max-w-md sm:w-full sm:p-6"
              role="dialog">
              <div class="sm:block absolute top-0 right-0 pt-4 pr-4">
                <button aria-label="Close"
                  class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
                  type="button" @click="dSecureModal">
                  <!-- Heroicon name: x -->
                  <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                  </svg>
                </button>
              </div>
              <div class="mt-5 sm:mt-6 overflow-x-auto">
                <!-- The Payment iFrame -->
                <iframe frameborder="0" width="390" height="400" name="payment-iframe"></iframe>
                <!-- The Device Data Collection iFrame. Required for 3DS 2.0 -->
                <iframe name="cardinal-collection-iframe" height="10" width="10" style="display:none;"></iframe>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>

    <transition enter-active-class="ease-out duration-300" enter-class="opacity-0" enter-to-class="opacity-100"
      leave-active-class="ease-in duration-200" leave-class="opacity-100" leave-to-class="opacity-0">
      <div v-if="showOtp" class="fixed z-50 inset-0 overflow-y-auto ">
        <div class="fixed inset-0 bg-gray-600 bg-opacity-50 " @click="closeModal"></div>
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 relative">

          <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
          <transition enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100" leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div aria-labelledby="modal-headline" aria-modal="true"
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md w-full max-w-xs sm:w-full sm:p-6"
              role="dialog">

              <div class="sm:block absolute top-0 right-0 pt-4 pr-4">
                <button class="" @click="closeModal">
                  <svg width="24" height="24" viewBox="0 0 32 32" fill="none">
                    <path
                      d="M24.4 7.61329C23.88 7.09329 23.04 7.09329 22.52 7.61329L16 14.12L9.47996 7.59996C8.95996 7.07996 8.11996 7.07996 7.59996 7.59996C7.07996 8.11996 7.07996 8.95996 7.59996 9.47996L14.12 16L7.59996 22.52C7.07996 23.04 7.07996 23.88 7.59996 24.4C8.11996 24.92 8.95996 24.92 9.47996 24.4L16 17.88L22.52 24.4C23.04 24.92 23.88 24.92 24.4 24.4C24.92 23.88 24.92 23.04 24.4 22.52L17.88 16L24.4 9.47996C24.9066 8.97329 24.9066 8.11996 24.4 7.61329Z"
                      fill="#616163" />
                  </svg>
                </button>
              </div>
              <div class="mx-auto flex items-center justify-center h-16 w-16 ">

                <svg width="55" height="85" viewBox="0 0 55 85" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="h-12 w-12 text-green-600">
                  <path
                    d="M6.31574 0H30.9158C32.6543 0 34.2341 0.717928 35.3801 1.86946C36.5227 3.02454 37.235 4.61678 37.235 6.36539V34.5423C40.4123 35.8111 41.8722 38.3985 43.311 40.9503C44.2984 42.7025 45.2752 44.4334 46.7986 45.3468C48.3361 46.2708 49.6867 47.33 50.6705 48.6343C51.7249 50.0382 52.3314 51.6731 52.2644 53.642C52.0176 60.8853 52.61 64.2155 53.6397 69.998C53.9747 71.8604 54.3485 73.9715 54.747 76.4771C55.3112 78.0018 54.8034 79.395 53.5727 80.6141C52.6911 81.4884 51.3864 82.2668 49.8665 82.91C48.4207 83.5249 46.7704 84.0331 45.1165 84.3957C40.3241 85.4441 35.1862 85.2167 33.7862 83.0131C33.7157 82.8994 33.6593 82.7821 33.6205 82.6648C33.5076 82.3414 33.3595 81.9469 33.1867 81.4991L32.7072 80.2871C30.9122 78.7944 29.0785 77.1808 27.4246 75.4002C25.8307 73.6872 24.4237 71.8319 23.4046 69.8061C21.8001 69.5751 20.9361 69.7314 19.4198 70.0051C18.7603 70.1259 18.0022 70.261 17.2722 70.3712C15.0012 70.7159 13.3297 69.5502 12.4305 67.8904C12.0532 67.2009 11.8204 66.4119 11.7499 65.6229C11.6758 64.8126 11.7675 63.9916 12.0391 63.2523L12.1025 63.0995C12.1625 62.9573 12.226 62.8187 12.2965 62.6801H6.31574C4.58077 62.6801 3.00095 61.9657 1.85487 60.8107C0.712328 59.6591 0 58.0669 0 56.3147V6.36539C0 4.61678 0.712328 3.02454 1.85487 1.86946C3.00095 0.717928 4.58077 0 6.31574 0ZM37.235 51.7903L40.3277 54.9073C41.0153 55.5968 41.0188 56.7163 40.3347 57.4058C39.6541 58.0953 38.5433 58.0989 37.8592 57.4129L34.2447 53.77C32.3863 52.1849 30.4221 50.6175 28.3697 49.0608C26.1728 47.3939 23.8383 45.7164 21.3945 44.0246C20.2238 43.2108 19.1976 43.1112 18.4535 43.4276C18.1221 43.5697 17.8329 43.8007 17.6037 44.0886C17.3639 44.3872 17.1946 44.7426 17.11 45.1193C16.9231 45.9616 17.1594 46.9461 17.9916 47.7564C20.2061 49.9244 22.1492 51.9325 23.9512 54.0472C25.5944 55.9735 27.1214 57.9851 28.6342 60.2811C28.9657 60.5299 29.1984 60.9031 29.2584 61.3402C29.3113 61.4966 29.3395 61.6672 29.3395 61.8413C29.3395 61.9089 29.3359 61.98 29.3289 62.0475C29.5687 64.4287 29.9707 66.2342 30.6795 67.7909C31.4412 69.472 32.6014 70.9576 34.3363 72.6636C34.9676 73.282 34.9817 74.2985 34.3681 74.9382C33.7545 75.5708 32.7459 75.585 32.1112 74.9666C30.0976 72.9834 28.7294 71.21 27.7808 69.1237C27.0262 67.4675 26.5642 65.6656 26.2715 63.462L16.4012 63.5366C15.6924 63.5438 15.2586 63.8636 15.0647 64.2901L15.04 64.3719C14.9307 64.6669 14.8954 65.0009 14.9236 65.335C14.9554 65.6904 15.0612 66.0458 15.2269 66.355C15.5302 66.9059 16.0768 67.2969 16.8102 67.1867C17.7412 67.0481 18.3407 66.9379 18.8555 66.8455C20.9961 66.4581 22.0716 66.2626 24.7799 66.7744C25.2771 66.8704 25.7214 67.2009 25.9436 67.7021C26.8216 69.6924 28.1758 71.5192 29.7485 73.2074C31.3354 74.9169 33.1656 76.5127 34.964 78.0018C35.2038 78.1724 35.3978 78.4141 35.5177 78.7091L36.1595 80.3262L36.558 81.3924C37.3761 82.2419 40.9201 82.018 44.4429 81.2467C45.9417 80.9198 47.398 80.4755 48.6288 79.953C49.7925 79.459 50.7481 78.901 51.337 78.3217C51.6438 78.0161 51.806 77.7495 51.7496 77.5611C51.6896 77.4332 51.6509 77.2946 51.6262 77.1489C51.2101 74.5295 50.8363 72.4184 50.5048 70.5631C49.4363 64.5673 48.8192 61.1092 49.0766 53.539C49.1189 52.3732 48.7592 51.4065 48.1351 50.5748C47.4368 49.6472 46.386 48.8404 45.1623 48.1047C42.9195 46.7577 41.7347 44.6573 40.5392 42.5355C39.6189 40.9077 38.6914 39.2621 37.235 38.1995V51.7903ZM18.6157 10.7334C24.7869 10.7334 29.7908 15.7731 29.7908 21.9928C29.7908 28.2124 24.7869 33.2557 18.6157 33.2557C12.4446 33.2557 7.44418 28.2124 7.44418 21.9928C7.44418 15.7731 12.4446 10.7334 18.6157 10.7334ZM12.099 22.4406L15.4561 26.6309C16.0627 27.3914 17.1664 27.5087 17.9211 26.8974L25.0126 19.7075C25.6932 19.018 25.6897 17.8984 25.0055 17.2125C24.3214 16.5266 23.2106 16.5266 22.5265 17.2196L16.9584 22.8777L14.8319 20.2264C14.2219 19.4658 13.1181 19.345 12.367 19.9563C11.6124 20.5676 11.4925 21.68 12.099 22.4406ZM34.0331 49.4304V35.7009V6.36539C34.0331 5.5053 33.684 4.71629 33.1162 4.14763C32.552 3.57898 31.7727 3.22357 30.9158 3.22357H6.31574C5.46236 3.22357 4.6795 3.57898 4.11528 4.14763C3.55106 4.71629 3.19842 5.5053 3.19842 6.36539V56.3147C3.19842 57.1784 3.55106 57.9638 4.11528 58.5325C4.6795 59.1011 5.46236 59.4565 6.31574 59.4565H24.1627C23.3094 58.3015 22.4383 57.2032 21.525 56.137L21.4897 56.0944L21.4792 56.105L21.4545 56.1264L21.3981 56.1726L21.3804 56.1868L21.3557 56.2045L21.3416 56.2152L21.3134 56.2401L21.3028 56.2472L21.2711 56.2721L21.2676 56.2756L21.19 56.3325L21.183 56.336L21.1512 56.3609L21.1406 56.368L21.1089 56.3858L21.0701 56.4142L21.0525 56.4284L21.0313 56.4427L21.0066 56.4569L20.989 56.4675L20.9608 56.4853L20.9502 56.4924L20.9149 56.5137L20.9079 56.5173L20.8691 56.5422L20.8268 56.5671L20.8233 56.5706L20.7845 56.5919L20.7774 56.5955L20.7422 56.6133L20.7316 56.6204L20.6998 56.6381L20.6822 56.6488L20.6575 56.6595L20.6328 56.6737L20.6152 56.6843L20.587 56.6986L20.5694 56.7057L20.5376 56.7199L20.527 56.727L20.4918 56.7448L20.4847 56.7483L20.4389 56.7661L20.3966 56.7874L20.393 56.791L20.3507 56.8052L20.3401 56.8123L20.3084 56.8265L20.2908 56.8336L20.2626 56.8443L20.2414 56.8514L20.2167 56.862L20.192 56.8727L20.1709 56.8798L20.1391 56.8905L20.125 56.894L20.0898 56.9083L20.0792 56.9118L20.0369 56.9296H20.0334L19.9875 56.9438L19.9417 56.958L19.9346 56.9616L19.8958 56.9758L19.8817 56.9793L19.85 56.9864L19.8288 56.9935L19.8006 57.0007L19.7759 57.0078L19.7548 57.0149L19.723 57.022L19.7089 57.0255L19.6701 57.0362L19.6596 57.0398L19.6172 57.0504H19.6102L19.5643 57.0611L19.515 57.0717H19.5114L19.4656 57.0824H19.455L19.4198 57.0895L19.4021 57.0931L19.3704 57.1002L19.3457 57.1037L19.321 57.1073L19.2928 57.1108L19.2717 57.1144L19.2364 57.1215H19.2223L19.18 57.1286H19.1729L19.1271 57.1357H19.1235L19.0742 57.1393H19.0707L19.0213 57.1464H19.0142L18.9719 57.1499H18.9578L18.9225 57.1535H18.9014L18.8732 57.157H18.845H18.8203L18.7885 57.1606H18.7709L18.7321 57.1642H18.7215H18.6757H18.6686H18.6157C17.3956 57.1642 16.2848 56.663 15.4843 55.8527C14.6733 55.0424 14.176 53.9228 14.176 52.6895V52.6327L14.1796 52.5794V52.5722V52.526V52.5154L14.1831 52.4692V52.4585L14.1866 52.4159V52.4017L14.1901 52.3626V52.3448L14.1937 52.3057L14.1972 52.2879V52.2524L14.2007 52.2311L14.2042 52.1991L14.2078 52.1777L14.2113 52.1458L14.2148 52.1209V52.0924L14.2219 52.064L14.2254 52.0391L14.2289 52.0071L14.2325 51.9858L14.236 51.9538L14.2395 51.9325L14.2466 51.897L14.2501 51.8828L14.2571 51.8437L14.2607 51.8294L14.2677 51.7868L14.2713 51.7761L14.2783 51.7335L14.2818 51.7228L14.2924 51.6802V51.6731L14.303 51.6233L14.3065 51.6198L14.3171 51.5735V51.57L14.3312 51.5202V51.5167L14.3453 51.4669V51.4634L14.3594 51.4172V51.4136L14.3735 51.3674L14.377 51.3603L14.3911 51.3176L14.3947 51.307L14.4053 51.2679L14.4123 51.2537L14.4229 51.2181L14.4299 51.2039L14.4405 51.1684L14.4476 51.1506L14.4581 51.1186L14.4652 51.1009L14.4758 51.0724L14.4864 51.0475L14.4969 51.0227L14.5075 50.9978L14.5146 50.9765L14.5252 50.948L14.5357 50.9267L14.5498 50.8983L14.5569 50.8805L14.571 50.8485L14.578 50.8343L14.5922 50.7988L14.5992 50.7845L14.6168 50.749L14.6204 50.7383L14.638 50.7028L14.645 50.6921L14.6627 50.653L14.6662 50.6459L14.6874 50.6033L14.6909 50.5997L14.712 50.5571L14.7156 50.5535L14.7403 50.5109L14.7649 50.4647V50.4611L14.7896 50.422L14.7932 50.4149L14.8425 50.3332L14.8496 50.3225L14.8707 50.2905L14.8778 50.2799L14.8989 50.2443L14.906 50.2337L14.9272 50.2017L14.9342 50.1874L14.9554 50.159L14.9659 50.1448L14.9977 50.0986L15.0118 50.0773L15.0294 50.0559L15.0435 50.0346L15.0612 50.0133L15.0753 49.992L15.0929 49.9706L15.1035 49.9529L15.1246 49.928L15.1352 49.9138L15.1564 49.8853L15.167 49.8747L15.1916 49.8427L15.2516 49.7716L15.2622 49.761L15.2657 49.7574L15.2974 49.7219L15.3292 49.6863L15.3327 49.6828V49.6792L15.368 49.6401C13.9821 48.0443 13.6224 46.1251 13.9997 44.4263C14.1901 43.5591 14.578 42.7487 15.1176 42.0734C15.6642 41.3875 16.38 40.826 17.2158 40.4705C18.8908 39.7562 21.0102 39.8592 23.2071 41.3804C25.6544 43.0721 28.0206 44.7781 30.281 46.4912C31.5752 47.4721 32.8306 48.453 34.0331 49.4304ZM20.0757 54.495C19.0742 53.3897 18.0127 52.2915 16.8808 51.1613L16.8737 51.1684L16.8631 51.179L16.8526 51.1897L16.8455 51.2004L16.8385 51.211L16.8314 51.2181L16.8208 51.2324L16.8138 51.2395L16.8032 51.2537L16.7997 51.2572L16.7856 51.275L16.782 51.2786L16.7679 51.2999L16.7538 51.3212H16.7503L16.7362 51.339V51.3425L16.7221 51.3603L16.7186 51.3674L16.708 51.3816L16.7045 51.3887L16.6939 51.403L16.6903 51.4136L16.6798 51.4243L16.6727 51.4349L16.6657 51.4456L16.6586 51.4598L16.6551 51.4669L16.6445 51.4847L16.641 51.4883L16.6304 51.5096L16.6269 51.5131L16.6163 51.5309V51.5345L16.6022 51.5558L16.5916 51.5771L16.5881 51.5807L16.5775 51.602L16.574 51.6055L16.5669 51.6233L16.5634 51.6304L16.5528 51.6482L16.5493 51.6553L16.5422 51.6695L16.5387 51.6802L16.5317 51.6944L16.5246 51.7086L16.5211 51.7157L16.514 51.7335L16.5105 51.7406L16.5034 51.7584L16.4999 51.7619L16.4929 51.7832L16.4893 51.7868L16.4823 51.8117L16.4717 51.8366L16.4611 51.8579V51.865L16.4541 51.8828L16.4506 51.8899L16.4435 51.9076L16.44 51.9183L16.4364 51.9325L16.4329 51.9432L16.4259 51.9574L16.4223 51.9716L16.4188 51.9823L16.4153 52L16.4118 52.0071L16.4047 52.0249V52.032L16.3977 52.0534V52.0569L16.3906 52.0818L16.3836 52.1067V52.1102L16.3765 52.1315V52.1351L16.3694 52.1564V52.1635L16.3659 52.1849L16.3624 52.192L16.3589 52.2097V52.2204L16.3553 52.2346L16.3518 52.2488L16.3483 52.2595L16.3448 52.2773V52.2879L16.3412 52.3057V52.3128L16.3377 52.3341V52.3412L16.3307 52.3626V52.3661V52.391V52.3945L16.3271 52.4194V52.423L16.3236 52.4443V52.4514L16.3201 52.4727V52.4798V52.5012L16.3165 52.5118V52.526V52.5403L16.313 52.5509V52.5687V52.5794V52.6007V52.6078V52.6291V52.6327L16.3095 52.6576V52.6611V52.6895C16.3095 53.3293 16.5669 53.9121 16.9866 54.3351C17.4027 54.7545 17.9775 55.0139 18.6157 55.0139H18.644H18.6475H18.6686H18.6757H18.6969H18.7074H18.7215L18.7356 55.0104H18.7462H18.7674H18.7709L18.7956 55.0068H18.7991H18.8238L18.8485 55.0033H18.852L18.8732 54.9997H18.8838L18.8979 54.9961H18.912L18.9225 54.9926H18.9402L18.9508 54.989L18.9684 54.9855H18.9754L18.9966 54.9819H19.0001L19.0213 54.9784H19.0283L19.0495 54.9748H19.053L19.0742 54.9677H19.0848L19.0953 54.9642L19.113 54.9606H19.12L19.1377 54.9535H19.1447L19.1659 54.9464H19.1694L19.1941 54.9428L19.2188 54.9357H19.2223L19.2434 54.9286L19.2505 54.9251L19.2646 54.9215L19.2787 54.918L19.2893 54.9144L19.3034 54.9108L19.314 54.9073L19.3316 54.9002H19.3351L19.3598 54.8931L19.381 54.8824H19.3845L19.4057 54.8753H19.4127L19.4268 54.8682L19.4374 54.8646L19.4515 54.8575L19.4656 54.854L19.4727 54.8504L19.4903 54.8433L19.4973 54.8398L19.5185 54.8327V54.8291L19.5432 54.822L19.5643 54.8113L19.5679 54.8078L19.5855 54.8007L19.5926 54.7971L19.6102 54.79L19.6172 54.7865L19.6313 54.7793L19.6455 54.7722L19.6525 54.7687L19.6701 54.7616L19.6737 54.758L19.6948 54.7474L19.716 54.7367L19.7195 54.7331L19.7371 54.7225H19.7442L19.7583 54.7118L19.7653 54.7083L19.7795 54.7012L19.79 54.694L19.8006 54.6869L19.8147 54.6798L19.8218 54.6763L19.8394 54.6656L19.8429 54.6621L19.8641 54.6478L19.8817 54.6372L19.8852 54.6336L19.9029 54.623L19.9099 54.6194L19.924 54.6087L19.9311 54.6016L19.9417 54.5945L19.9558 54.5874L19.9628 54.5803L19.9769 54.5697L19.9805 54.5661L19.9981 54.5519H20.0016L20.0192 54.5377L20.0404 54.5234L20.0439 54.5199L20.058 54.5092L20.0651 54.5021L20.0757 54.495Z"
                    fill="#7B7B7C" />
                  <rect x="6.24951" y="7.88281" width="24.7163" height="29.181" fill="white" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M27.4379 21.6375C27.4379 23.964 26.5209 26.1953 24.8886 27.8404C23.2563 29.4855 21.0425 30.4097 18.7341 30.4097C16.4257 30.4097 14.2118 29.4855 12.5796 27.8404C10.9473 26.1953 10.0303 23.964 10.0303 21.6375C10.0303 19.3109 10.9473 17.0797 12.5796 15.4346C14.2118 13.7894 16.4257 12.8652 18.7341 12.8652C21.0425 12.8652 23.2563 13.7894 24.8886 15.4346C26.5209 17.0797 27.4379 19.3109 27.4379 21.6375ZM23.1186 18.315C23.0409 18.2369 22.9484 18.1755 22.8466 18.1343C22.7447 18.0931 22.6357 18.073 22.526 18.0753C22.4163 18.0776 22.3082 18.1021 22.2082 18.1474C22.1081 18.1927 22.0181 18.2579 21.9436 18.3391L18.1651 23.1913L15.8879 20.8951C15.7333 20.7499 15.5287 20.6708 15.3173 20.6745C15.1059 20.6783 14.9042 20.7646 14.7547 20.9153C14.6052 21.066 14.5195 21.2692 14.5158 21.4823C14.5121 21.6953 14.5905 21.9015 14.7347 22.0574L17.6135 24.96C17.691 25.038 17.7834 25.0995 17.885 25.1407C17.9867 25.182 18.0955 25.2022 18.2051 25.2002C18.3146 25.1981 18.4226 25.1739 18.5227 25.1288C18.6227 25.0838 18.7128 25.0189 18.7874 24.938L23.1306 19.4663C23.2787 19.3112 23.3605 19.1037 23.3584 18.8884C23.3564 18.6732 23.2707 18.4673 23.1197 18.315H23.1186Z"
                    fill="#08849D" />
                </svg>

              </div>
              <validation-observer ref="otpForm">
                <form @submit.prevent="ProceedWithOTP">
                  <div class="mt-3 text-center sm:mt-3">
                    <h3 id="modal-headline" class="text-xl leading-6 font-medium text-gray-900">
                      {{ $t('comman.enter_OTP') }}
                    </h3>
                    <div class="mt-2">
                      <div class="mt-5">
                        <validation-provider v-slot="{ failed, errors }" name="otp" rules="required">
                          <div class="mt-1 relative rounded-lg shadow-sm ">

                            <input id="otp" v-model="otp" type="text" autocomplete="off" inputmode="numeric"
                              :placeholder="$t('comman.type_OTP')"
                              class="form-input relative block w-full rounded-none rounded-br-lg bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5 textFieldStyle"
                              v-cleave="{
                                blocks: [6],
                                numericOnly: true,
                              }" :class="!failed ? '' : 'border-red-300  border-red-300  textFieldStyleError'" />
                            <div id="otp-error"
                              class="absolute mt-2 top-10 left-0 text-xs mt-1 error-msg-text text-right normal-case textError "
                              :class="{ 'right-0': isRtl, 'left-0': !isRtl }">
                              {{ errors[0] }}
                            </div>

                          </div>
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <div class="mt-8 sm:mt-8">
                    <span class="flex w-full rounded-lg shadow-sm">
                      <button :disabled="otpLoad"
                        class="w-full inline-flex justify-center rounded-lg border border-transparent shadow-sm px-4 py-2 payBtn text-base font-medium text-white  sm:col-start-2 sm:text-sm primary-btn"
                        type="submit">
                        <span v-show="!otpLoad">
                          {{ $t('comman.verify_Pay') }}
                        </span>
                        <svg v-show="otpLoad"
                          :class="`animate-spin h-5 w-5 text-white ${isRtl ? 'ml-3 -mr-1' : '-ml-1 mr-3'}`" fill="none"
                          viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                          </circle>
                          <path class="opacity-75"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            fill="currentColor"></path>
                        </svg>
                        <span v-show="otpLoad"> {{ $t('comman.verifying') }} </span>
                      </button>
                    </span>
                  </div>
                </form>
              </validation-observer>
            </div>
          </transition>
        </div>
      </div>
    </transition>
    <transition enter-active-class="ease-out duration-300" enter-class="opacity-0" enter-to-class="opacity-100"
      leave-active-class="ease-in duration-200" leave-class="opacity-100" leave-to-class="opacity-0">
      <div v-show="isScanQRModalOpen" class="fixed z-50 inset-0 overflow-y-auto">
        <div class="fixed inset-0 z-50 flex items-center justify-center bg-gray-400 bg-opacity-50">
          <div class="bg-white p-6 rounded-3xl shadow-lg w-full max-w-xl relative mx-4">
            <div class="sm:block absolute top-0 right-0 pt-4 pr-4">
              <button class="" @click="isScanQRModalOpen = false">
                <svg width="24" height="24" viewBox="0 0 32 32" fill="none">
                  <path
                    d="M24.4 7.61329C23.88 7.09329 23.04 7.09329 22.52 7.61329L16 14.12L9.47996 7.59996C8.95996 7.07996 8.11996 7.07996 7.59996 7.59996C7.07996 8.11996 7.07996 8.95996 7.59996 9.47996L14.12 16L7.59996 22.52C7.07996 23.04 7.07996 23.88 7.59996 24.4C8.11996 24.92 8.95996 24.92 9.47996 24.4L16 17.88L22.52 24.4C23.04 24.92 23.88 24.92 24.4 24.4C24.92 23.88 24.92 23.04 24.4 22.52L17.88 16L24.4 9.47996C24.9066 8.97329 24.9066 8.11996 24.4 7.61329Z"
                    fill="#616163" />
                </svg>
              </button>
            </div>
            <div>
              <svg width="100" height="101" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"
                class=" mx-auto">
                <path
                  d="M46.875 22.375V41.125C46.875 42.7826 46.2165 44.3723 45.0444 45.5444C43.8723 46.7165 42.2826 47.375 40.625 47.375H21.875C20.2174 47.375 18.6277 46.7165 17.4556 45.5444C16.2835 44.3723 15.625 42.7826 15.625 41.125V22.375C15.625 20.7174 16.2835 19.1277 17.4556 17.9556C18.6277 16.7835 20.2174 16.125 21.875 16.125H40.625C42.2826 16.125 43.8723 16.7835 45.0444 17.9556C46.2165 19.1277 46.875 20.7174 46.875 22.375ZM40.625 53.625H21.875C20.2174 53.625 18.6277 54.2835 17.4556 55.4556C16.2835 56.6277 15.625 58.2174 15.625 59.875V78.625C15.625 80.2826 16.2835 81.8723 17.4556 83.0444C18.6277 84.2165 20.2174 84.875 21.875 84.875H40.625C42.2826 84.875 43.8723 84.2165 45.0444 83.0444C46.2165 81.8723 46.875 80.2826 46.875 78.625V59.875C46.875 58.2174 46.2165 56.6277 45.0444 55.4556C43.8723 54.2835 42.2826 53.625 40.625 53.625ZM78.125 16.125H59.375C57.7174 16.125 56.1277 16.7835 54.9556 17.9556C53.7835 19.1277 53.125 20.7174 53.125 22.375V41.125C53.125 42.7826 53.7835 44.3723 54.9556 45.5444C56.1277 46.7165 57.7174 47.375 59.375 47.375H78.125C79.7826 47.375 81.3723 46.7165 82.5444 45.5444C83.7165 44.3723 84.375 42.7826 84.375 41.125V22.375C84.375 20.7174 83.7165 19.1277 82.5444 17.9556C81.3723 16.7835 79.7826 16.125 78.125 16.125ZM56.25 72.375C57.0788 72.375 57.8737 72.0458 58.4597 71.4597C59.0458 70.8737 59.375 70.0788 59.375 69.25V56.75C59.375 55.9212 59.0458 55.1263 58.4597 54.5403C57.8737 53.9542 57.0788 53.625 56.25 53.625C55.4212 53.625 54.6263 53.9542 54.0403 54.5403C53.4542 55.1263 53.125 55.9212 53.125 56.75V69.25C53.125 70.0788 53.4542 70.8737 54.0403 71.4597C54.6263 72.0458 55.4212 72.375 56.25 72.375ZM81.25 59.875H71.875V56.75C71.875 55.9212 71.5458 55.1263 70.9597 54.5403C70.3737 53.9542 69.5788 53.625 68.75 53.625C67.9212 53.625 67.1263 53.9542 66.5403 54.5403C65.9542 55.1263 65.625 55.9212 65.625 56.75V78.625H56.25C55.4212 78.625 54.6263 78.9542 54.0403 79.5403C53.4542 80.1263 53.125 80.9212 53.125 81.75C53.125 82.5788 53.4542 83.3737 54.0403 83.9597C54.6263 84.5458 55.4212 84.875 56.25 84.875H68.75C69.5788 84.875 70.3737 84.5458 70.9597 83.9597C71.5458 83.3737 71.875 82.5788 71.875 81.75V66.125H81.25C82.0788 66.125 82.8737 65.7958 83.4597 65.2097C84.0458 64.6237 84.375 63.8288 84.375 63C84.375 62.1712 84.0458 61.3763 83.4597 60.7903C82.8737 60.2042 82.0788 59.875 81.25 59.875ZM81.25 72.375C80.4212 72.375 79.6263 72.7042 79.0403 73.2903C78.4542 73.8763 78.125 74.6712 78.125 75.5V81.75C78.125 82.5788 78.4542 83.3737 79.0403 83.9597C79.6263 84.5458 80.4212 84.875 81.25 84.875C82.0788 84.875 82.8737 84.5458 83.4597 83.9597C84.0458 83.3737 84.375 82.5788 84.375 81.75V75.5C84.375 74.6712 84.0458 73.8763 83.4597 73.2903C82.8737 72.7042 82.0788 72.375 81.25 72.375Z"
                  fill="#3C90A8" />
              </svg>
              <h3 class="text-lg font-bold mb-2 text-center mb-2 font-bold"> {{ $t('tabs.Scan_QR') }}</h3>
              <div class="mb-4">
                <div class="flex items-start gap-2" :class="{ 'justify-end': isRtl }">
                  <svg :class="{ 'order-2': isRtl }" class="mt-1" width="10" height="11" viewBox="0 0 10 11" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5" cy="5.5" r="5" fill="#3C90A8" />
                  </svg>

                  <span class="font-bold text-gray-900 text-sm m-0 p-0"> {{ $t('tabs.What_Scan_Pay') }}</span>
                </div>
                <div class="flex items-start text-start">
                  <p class="text-start text-sm text-gray-500 leading-6 my-2">
                    {{ $t('tabs.Scan_Pay_des') }}
                  </p>
                </div>
              </div>

              <div class="mb-4">
                <div class="flex items-start gap-2" :class="{ 'justify-end': isRtl }">
                  <svg :class="{ 'order-2': isRtl }" class="mt-1" width="10" height="11" viewBox="0 0 10 11" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5" cy="5.5" r="5" fill="#3C90A8" />
                  </svg>

                  <span class="font-bold text-gray-900 text-sm m-0 p-0">{{ $t('tabs.Who_allowed') }} </span>
                </div>
                <div class="flex items-start text-start">
                  <p class="text-start text-sm text-gray-500 leading-6 my-2">
                    {{ $t('tabs.Who_allowed_des') }}
                  </p>
                </div>
              </div>

              <div class="mb-4">
                <div class="flex items-start gap-2" :class="{ 'justify-end': isRtl }">
                  <svg :class="{ 'order-2': isRtl }" class="mt-1" width="10" height="11" viewBox="0 0 10 11" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5" cy="5.5" r="5" fill="#3C90A8" />
                  </svg>

                  <span class="font-bold text-gray-900 text-sm m-0 p-0"> {{ $t('tabs.How_to_use') }}</span>
                </div>
                <div class="flex items-start text-start">
                  <ul class="list-none space-y-2 mb-4  my-2">
                    <li class="flex items-start text-xs lg:text-sm"
                      :class="{ 'flex-row-reverse justify-end gap-3': isRtl, 'flex-row gap-3': !isRtl }">
                      <svg :class="{ 'order-2': isRtl, 'order-1': !isRtl }" width="24" height="24" viewBox="0 0 16 16"
                        fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="8" fill="#EFEFEF" />
                        <path
                          d="M8 13C7.30833 13 6.65833 12.8688 6.05 12.6062C5.44167 12.3438 4.9125 11.9875 4.4625 11.5375C4.0125 11.0875 3.65625 10.5583 3.39375 9.95C3.13125 9.34167 3 8.69167 3 8C3 7.30833 3.13125 6.65833 3.39375 6.05C3.65625 5.44167 4.0125 4.9125 4.4625 4.4625C4.9125 4.0125 5.44167 3.65625 6.05 3.39375C6.65833 3.13125 7.30833 3 8 3C8.4 3 8.78958 3.04583 9.16875 3.1375C9.54792 3.22917 9.9125 3.3625 10.2625 3.5375C10.3875 3.60417 10.4688 3.70417 10.5062 3.8375C10.5438 3.97083 10.5208 4.09583 10.4375 4.2125C10.3542 4.32917 10.2438 4.40417 10.1063 4.4375C9.96875 4.47083 9.83333 4.45417 9.7 4.3875C9.43333 4.2625 9.15625 4.16667 8.86875 4.1C8.58125 4.03333 8.29167 4 8 4C6.89167 4 5.94792 4.38958 5.16875 5.16875C4.38958 5.94792 4 6.89167 4 8C4 9.10833 4.38958 10.0521 5.16875 10.8313C5.94792 11.6104 6.89167 12 8 12C9.10833 12 10.0521 11.6104 10.8313 10.8313C11.6104 10.0521 12 9.10833 12 8C12 7.93333 11.9979 7.86875 11.9938 7.80625C11.9896 7.74375 11.9833 7.67917 11.975 7.6125C11.9583 7.47083 11.9854 7.33542 12.0563 7.20625C12.1271 7.07708 12.2333 6.99167 12.375 6.95C12.5083 6.90833 12.6333 6.92083 12.75 6.9875C12.8667 7.05417 12.9333 7.15417 12.95 7.2875C12.9667 7.40417 12.9792 7.52083 12.9875 7.6375C12.9958 7.75417 13 7.875 13 8C13 8.69167 12.8688 9.34167 12.6062 9.95C12.3438 10.5583 11.9875 11.0875 11.5375 11.5375C11.0875 11.9875 10.5583 12.3438 9.95 12.6062C9.34167 12.8688 8.69167 13 8 13ZM7.3 8.9L11.95 4.2375C12.0417 4.14583 12.1562 4.09792 12.2937 4.09375C12.4313 4.08958 12.55 4.1375 12.65 4.2375C12.7417 4.32917 12.7875 4.44583 12.7875 4.5875C12.7875 4.72917 12.7417 4.84583 12.65 4.9375L7.65 9.95C7.55 10.05 7.43333 10.1 7.3 10.1C7.16667 10.1 7.05 10.05 6.95 9.95L5.525 8.525C5.43333 8.43333 5.3875 8.31667 5.3875 8.175C5.3875 8.03333 5.43333 7.91667 5.525 7.825C5.61667 7.73333 5.73333 7.6875 5.875 7.6875C6.01667 7.6875 6.13333 7.73333 6.225 7.825L7.3 8.9Z"
                          fill="#08849D" />
                      </svg>
                      <p class="text-gray-500"
                        :class="{ 'order-1': isRtl, 'order-2': !isRtl, 'ml-2': isRtl, 'mr-2': !isRtl }">{{
                          $t('tabs.Agree_terms_conditions') }}</p>
                    </li>
                    <li class="flex items-start text-xs lg:text-sm"
                      :class="{ 'flex-row-reverse justify-end gap-3': isRtl, 'flex-row gap-3': !isRtl }">
                      <svg :class="{ 'order-2': isRtl, 'order-1': !isRtl }" width="24" height="24" viewBox="0 0 16 16">
                        <circle cx="8" cy="8" r="8" fill="#EFEFEF" />
                        <path
                          d="M4.5 7.5H6.5C7.05 7.5 7.5 7.05 7.5 6.5V4.5C7.5 3.95 7.05 3.5 6.5 3.5H4.5C3.95 3.5 3.5 3.95 3.5 4.5V6.5C3.5 7.05 3.95 7.5 4.5 7.5ZM4.5 4.5H6.5V6.5H4.5V4.5Z"
                          fill="#08849D" />
                        <path
                          d="M4.5 12.5H6.5C7.05 12.5 7.5 12.05 7.5 11.5V9.5C7.5 8.95 7.05 8.5 6.5 8.5H4.5C3.95 8.5 3.5 8.95 3.5 9.5V11.5C3.5 12.05 3.95 12.5 4.5 12.5ZM4.5 9.5H6.5V11.5H4.5V9.5Z"
                          fill="#08849D" />
                        <path
                          d="M8.5 4.5V6.5C8.5 7.05 8.95 7.5 9.5 7.5H11.5C12.05 7.5 12.5 7.05 12.5 6.5V4.5C12.5 3.95 12.05 3.5 11.5 3.5H9.5C8.95 3.5 8.5 3.95 8.5 4.5ZM11.5 6.5H9.5V4.5H11.5V6.5Z"
                          fill="#08849D" />
                        <path
                          d="M12.5 12.25V11.75C12.5 11.61 12.39 11.5 12.25 11.5H11.75C11.61 11.5 11.5 11.61 11.5 11.75V12.25C11.5 12.39 11.61 12.5 11.75 12.5H12.25C12.39 12.5 12.5 12.39 12.5 12.25Z"
                          fill="#08849D" />
                        <path
                          d="M8.5 8.75V9.25C8.5 9.39 8.61 9.5 8.75 9.5H9.25C9.39 9.5 9.5 9.39 9.5 9.25V8.75C9.5 8.61 9.39 8.5 9.25 8.5H8.75C8.61 8.5 8.5 8.61 8.5 8.75Z"
                          fill="#08849D" />
                        <path
                          d="M10.25 9.5H9.75C9.61 9.5 9.5 9.61 9.5 9.75V10.25C9.5 10.39 9.61 10.5 9.75 10.5H10.25C10.39 10.5 10.5 10.39 10.5 10.25V9.75C10.5 9.61 10.39 9.5 10.25 9.5Z"
                          fill="#08849D" />
                        <path
                          d="M8.5 10.75V11.25C8.5 11.39 8.61 11.5 8.75 11.5H9.25C9.39 11.5 9.5 11.39 9.5 11.25V10.75C9.5 10.61 9.39 10.5 9.25 10.5H8.75C8.61 10.5 8.5 10.61 8.5 10.75Z"
                          fill="#08849D" />
                        <path
                          d="M9.75 12.5H10.25C10.39 12.5 10.5 12.39 10.5 12.25V11.75C10.5 11.61 10.39 11.5 10.25 11.5H9.75C9.61 11.5 9.5 11.61 9.5 11.75V12.25C9.5 12.39 9.61 12.5 9.75 12.5Z"
                          fill="#08849D" />
                        <path
                          d="M10.75 11.5H11.25C11.39 11.5 11.5 11.39 11.5 11.25V10.75C11.5 10.61 11.39 10.5 11.25 10.5H10.75C10.61 10.5 10.5 10.61 10.5 10.75V11.25C10.5 11.39 10.61 11.5 10.75 11.5Z"
                          fill="#08849D" />
                        <path
                          d="M11.25 8.5H10.75C10.61 8.5 10.5 8.61 10.5 8.75V9.25C10.5 9.39 10.61 9.5 10.75 9.5H11.25C11.39 9.5 11.5 9.39 11.5 9.25V8.75C11.5 8.61 11.39 8.5 11.25 8.5Z"
                          fill="#08849D" />
                        <path
                          d="M11.75 10.5H12.25C12.39 10.5 12.5 10.39 12.5 10.25V9.75C12.5 9.61 12.39 9.5 12.25 9.5H11.75C11.61 9.5 11.5 9.61 11.5 9.75V10.25C11.5 10.39 11.61 10.5 11.75 10.5Z"
                          fill="#08849D" />
                      </svg>
                      <p class="text-gray-500"
                        :class="{ 'order-1': isRtl, 'order-2': !isRtl, 'ml-2': isRtl, 'mr-2': !isRtl }">
                        {{ $t('tabs.generate_QR_code') }}</p>
                    </li>
                    <li class="flex items-start text-xs lg:text-sm"
                      :class="{ 'flex-row-reverse gap-3 justify-end': isRtl, 'flex-row gap-3': !isRtl }">
                      <svg
                        :class="{ 'order-2': isRtl, 'order-1': !isRtl, 'mr-0.5 md:-mr-0.5': isRtl, ' md:-mx-1 ': !isRtl }"
                        width="46" height="24" viewBox="0 0 16 16">
                        <circle cx="8" cy="8" r="8" fill="#EFEFEF" />
                        <path
                          d="M5.63632 13.3337C5.36966 13.3337 5.14137 13.2387 4.95147 13.0488C4.76158 12.8589 4.66663 12.6306 4.66663 12.364V3.63669C4.66663 3.37002 4.76158 3.14174 4.95147 2.95184C5.14137 2.76194 5.36966 2.66699 5.63632 2.66699H10.4848C10.7515 2.66699 10.9798 2.76194 11.1697 2.95184C11.3596 3.14174 11.4545 3.37002 11.4545 3.63669V12.364C11.4545 12.6306 11.3596 12.8589 11.1697 13.0488C10.9798 13.2387 10.7515 13.3337 10.4848 13.3337H5.63632ZM5.63632 10.9094V12.364H10.4848V10.9094H5.63632ZM8.06057 12.1215C8.19794 12.1215 8.31309 12.0751 8.40602 11.9821C8.49895 11.8892 8.54541 11.7741 8.54541 11.6367C8.54541 11.4993 8.49895 11.3842 8.40602 11.2912C8.31309 11.1983 8.19794 11.1518 8.06057 11.1518C7.92319 11.1518 7.80804 11.1983 7.71511 11.2912C7.62218 11.3842 7.57572 11.4993 7.57572 11.6367C7.57572 11.7741 7.62218 11.8892 7.71511 11.9821C7.80804 12.0751 7.92319 12.1215 8.06057 12.1215ZM5.63632 9.93972H10.4848V5.09123H5.63632V9.93972ZM5.63632 4.12154H10.4848V3.63669H5.63632V4.12154Z"
                          fill="#3C90A8" />
                      </svg>
                      <p class="text-gray-500"
                        :class="{ 'order-1': isRtl, 'order-2': !isRtl, 'ml-2': isRtl, 'mr-2': !isRtl }">
                        {{ $t('tabs.Download_screenshot_QR') }}</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="flex justify-center space-x-2">
                <a href="https://download.thawani.om" target="_blank">
                  <img src="@/assets/images/Scan_QR/appstore.svg" alt="App Store">
                </a>
                <a href="https://download.thawani.om" target="_blank">
                  <img src="@/assets/images/Scan_QR/googleplay.svg" alt="Google Play">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition enter-active-class="ease-out duration-300" enter-class="opacity-0" enter-to-class="opacity-100"
      leave-active-class="ease-in duration-200" leave-class="opacity-100" leave-to-class="opacity-0">
      <div v-show="isThawaniPayModalOpen" class="fixed z-50 inset-0 overflow-y-auto">
        <div class="fixed inset-0 z-50 flex items-center justify-center bg-gray-400 bg-opacity-50">
          <div class="bg-white p-6 rounded-3xl shadow-lg w-full max-w-xl relative mx-4">
            <div class="sm:block absolute top-0 right-0 pt-4 pr-4">
              <button class="" @click="isThawaniPayModalOpen = false">
                <svg width="24" height="24" viewBox="0 0 32 32" fill="none">
                  <path
                    d="M24.4 7.61329C23.88 7.09329 23.04 7.09329 22.52 7.61329L16 14.12L9.47996 7.59996C8.95996 7.07996 8.11996 7.07996 7.59996 7.59996C7.07996 8.11996 7.07996 8.95996 7.59996 9.47996L14.12 16L7.59996 22.52C7.07996 23.04 7.07996 23.88 7.59996 24.4C8.11996 24.92 8.95996 24.92 9.47996 24.4L16 17.88L22.52 24.4C23.04 24.92 23.88 24.92 24.4 24.4C24.92 23.88 24.92 23.04 24.4 22.52L17.88 16L24.4 9.47996C24.9066 8.97329 24.9066 8.11996 24.4 7.61329Z"
                    fill="#616163" />
                </svg>
              </button>
            </div>

            <div>
              <svg width="58" height="50" viewBox="0 0 58 50" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="mx-auto my-2">
                <path
                  d="M5.70991 21.9645H9.82864C9.98314 21.9645 10.1376 21.9727 10.2921 21.9793C10.3307 21.9878 10.3657 22.0083 10.3919 22.0378C10.4182 22.0673 10.4345 22.1043 10.4384 22.1437C10.4384 22.2406 10.4466 22.3359 10.4499 22.4329C10.4932 23.9799 10.7272 25.5156 11.1468 27.0053C12.0671 30.2502 13.8538 33.1833 16.315 35.4896C18.7763 37.7959 21.8191 39.3884 25.1169 40.0962C26.5365 40.3952 27.9858 40.5297 29.4362 40.4972C30.5574 40.4796 31.6743 40.353 32.771 40.1192C34.4604 39.7735 36.0919 39.1885 37.6161 38.3819C38.9535 37.6782 40.2007 36.8151 41.3306 35.8114C43.0714 34.268 44.5055 32.4101 45.5578 30.3351C46.2823 28.9235 46.8141 27.421 47.1389 25.8679C47.3181 25.0561 47.4363 24.2321 47.4922 23.4026C47.5169 22.9588 47.5514 22.5167 47.581 22.073C47.5851 22.035 47.6022 21.9997 47.6295 21.973C47.6568 21.9463 47.6925 21.9299 47.7305 21.9267C47.8456 21.9267 47.9623 21.9136 48.0773 21.9136L56.5466 21.9004C56.6435 21.9004 56.7405 21.9004 56.8358 21.9004C56.9772 21.9004 57.0593 21.9777 57.0577 22.1108C57.0577 22.4198 57.0445 22.7288 57.033 23.0378C57.033 23.1922 57.0067 23.3468 57.0002 23.5013C56.9027 25.5683 56.564 27.6169 55.991 29.6054C55.1571 32.5702 53.8327 35.3745 52.0728 37.902C49.7332 41.2876 46.6767 44.1163 43.1204 46.1871C40.7149 47.5958 38.1107 48.6337 35.3957 49.2655C34.398 49.4963 33.3885 49.6724 32.3716 49.7931C30.9892 49.9574 29.5969 50.0239 28.2052 49.992C27.3735 49.9755 26.5468 49.8934 25.7218 49.8013C25.1646 49.7389 24.6124 49.6517 24.0585 49.5597C22.7256 49.3332 21.4123 49.0035 20.1304 48.5736C16.4793 47.3531 13.1176 45.3959 10.2538 42.8232C7.38989 40.2505 5.08478 37.1172 3.48125 33.6173C2.56585 31.6325 1.89369 29.5442 1.47941 27.3981C1.32984 26.619 1.20494 25.8384 1.12276 25.0495C1.03237 24.185 0.958406 23.3188 0.943614 22.4477C0.938568 22.3515 0.944637 22.255 0.961696 22.1601C0.970768 22.1342 0.985285 22.1105 1.00428 22.0906C1.02327 22.0708 1.0463 22.0552 1.0718 22.045C1.14531 22.023 1.22191 22.013 1.29861 22.0155C1.53035 22.0155 1.7621 22.0155 1.99549 22.0155L5.70661 21.9843L5.70991 21.9645Z"
                  fill="#3C90A8" />
                <path
                  d="M42.0069 18.5097C42.0036 19.5992 41.6772 20.6633 41.0689 21.5672C40.4606 22.4711 39.5978 23.1742 38.5897 23.5875C37.5817 24.0008 36.4736 24.1058 35.4059 23.889C34.3381 23.6723 33.3587 23.1438 32.5915 22.3701C31.8243 21.5965 31.3039 20.6127 31.0962 19.5431C30.8884 18.4736 31.0026 17.3665 31.4243 16.3619C31.8461 15.3573 32.5564 14.5004 33.4654 13.8997C34.3743 13.299 35.4411 12.9815 36.5306 12.9874C37.2531 12.9893 37.9681 13.1338 38.6346 13.4126C39.3012 13.6913 39.9061 14.0989 40.4149 14.6119C40.9236 15.1249 41.3261 15.7333 41.5993 16.4022C41.8725 17.071 42.011 17.7872 42.0069 18.5097Z"
                  fill="#3C90A8" />
                <path
                  d="M34.1204 5.52243C34.1165 6.61129 33.7896 7.67451 33.1811 8.5775C32.5727 9.48049 31.71 10.1827 30.7023 10.5951C29.6945 11.0076 28.5871 11.1118 27.5201 10.8946C26.4531 10.6774 25.4746 10.1485 24.7083 9.3749C23.9421 8.60128 23.4226 7.6177 23.2156 6.54869C23.0086 5.47968 23.1234 4.37328 23.5455 3.36956C23.9676 2.36583 24.678 1.5099 25.5868 0.910099C26.4955 0.310302 27.5618 -0.00639951 28.6507 9.80092e-05C30.1077 0.00922618 31.5016 0.59564 32.5269 1.63081C33.5522 2.66598 34.1252 4.06544 34.1204 5.52243Z"
                  fill="#3C90A8" />
                <path
                  d="M21.91 24.0218C20.8211 24.0162 19.7582 23.6876 18.856 23.0777C17.9539 22.4677 17.253 21.6038 16.8422 20.5952C16.4313 19.5867 16.329 18.479 16.5481 17.4122C16.7671 16.3455 17.2978 15.3677 18.0729 14.6028C18.848 13.8378 19.8326 13.32 20.9022 13.115C21.9717 12.91 23.078 13.0269 24.081 13.451C25.0841 13.8751 25.9387 14.5873 26.5368 15.4974C27.1348 16.4075 27.4493 17.4746 27.4406 18.5635C27.4391 19.286 27.2945 20.001 27.0152 20.6673C26.7358 21.3336 26.3272 21.9379 25.813 22.4454C25.2988 22.9529 24.6891 23.3535 24.0192 23.6241C23.3493 23.8946 22.6325 24.0298 21.91 24.0218Z"
                  fill="#3C90A8" />
              </svg>

              <h3 class="text-lg font-bold text-center font-bold my-2"> {{ $t('tabs.Thawani_app') }}
              </h3>
              <div class="mb-4">
                <div class="flex items-start gap-2" :class="{ 'justify-end': isRtl }">
                  <svg :class="{ 'order-2': isRtl }" class="mt-1" width="10" height="11" viewBox="0 0 10 11" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5" cy="5.5" r="5" fill="#3C90A8" />
                  </svg>

                  <span class="font-bold text-gray-900 text-sm m-0 p-0"> {{ $t('tabs.what_thawani_pay') }} </span>
                </div>
                <div class="flex items-start text-start" :class="{ 'justify-end': isRtl }">
                  <p class="text-start text-sm text-gray-500 leading-6 my-2">
                    {{ $t('tabs.thawani_pay_des') }}
                  </p>
                </div>
              </div>
              <div class="mb-4">
                <div class="flex items-start gap-2" :class="{ 'justify-end': isRtl }">
                  <svg :class="{ 'order-2': isRtl }" class="mt-1" width="10" height="11" viewBox="0 0 10 11" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5" cy="5.5" r="5" fill="#3C90A8" />
                  </svg>

                  <span class="font-bold text-gray-900 text-sm m-0 p-0"> {{ $t('tabs.Who_allowed') }}</span>
                </div>
                <div class="flex items-start text-start" :class="{ 'justify-end': isRtl }">
                  <p class="text-start text-sm text-gray-500 leading-6 my-2">
                    {{ $t('tabs.Who_allowed_des_thawani_pay') }}
                  </p>
                </div>
              </div>
              <div class="mb-4">
                <div class="flex items-start gap-2" :class="{ 'justify-end': isRtl }">
                  <svg :class="{ 'order-2': isRtl }" class="mt-1" width="10" height="11" viewBox="0 0 10 11" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5" cy="5.5" r="5" fill="#3C90A8" />
                  </svg>

                  <span class="font-bold text-gray-900 text-sm m-0 p-0"> {{ $t('tabs.How_to_use') }} </span>
                </div>
                <div class="flex items-start text-start" :class="{ 'justify-end': isRtl }">
                  <p class="text-start text-sm text-gray-500 leading-6 my-2">
                    {{ $t('tabs.How_to_use_thawani_pay') }}
                  </p>
                </div>
              </div>

              <div class="flex justify-center space-x-2">
                <a href="https://download.thawani.om" target="_blank">
                  <img src="@/assets/images/Scan_QR/appstore.svg" alt="App Store">
                </a>
                <a href="https://download.thawani.om" target="_blank">
                  <img src="@/assets/images/Scan_QR/googleplay.svg" alt="Google Play">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div v-if="showIframe" class="overlay">
      <div class="box">
        <button class="close-btn" @click="closeIframe">×</button>
        <iframe ref="paReqIframe" class="frame"></iframe>
      </div>
    </div>

  </div>
</template>
<script src='https://cdn.jsdelivr.net/npm/axios/dist/axios.min.js'></script>
<script>
  import { onMounted, onBeforeUnmount, ref } from 'vue';
import Checkout from '../API/Checkout';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import MobileDetect from 'mobile-detect';
import { EventBus } from '@/eventBus';

const checkout = new Checkout();
const plain = (o) => JSON.parse(JSON.stringify(o));

export default {
  props: {
    sessionData: {
      type: Array,
      required: true,
    },
    qrCodeData: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      PUBLIC_KEY_BASE64: '',
      statusMsg: '',
      lastError: '',
      paymentsClient: null,
      scriptEl: null,
      thawaniPaymentUrl:
        'https://pre-uatcheckout.thawani.om/payWithThawaniApplication/' +
        this.$route.params.session,
      isApplePayAvailable: false,
      showApplePayCards: false,
      showIframe: false,
      paymentMethod: {},
      applePayRequest: {
        countryCode: 'OM',
        currencyCode: 'OMR',
        supportedNetworks: ['visa', 'masterCard'],
        merchantCapabilities: ['supports3DS'],
        total: {
          label: 'Thawani Checkout',
          amount: '27.00',
        },
      },
      isCancel: false,
      isTermsAccepted: false,
      isSaveCardDetails: false,
      purchaseLoad: false,
      cardType: '',
      showScanQRModal: false,
      cardInformation: {
        cardNumber: '',
        date: '',
        cvv: '',
        NameOnCard: '',
        saveCard: false,
        nickname: '',
      },
      hash: '',
      paymentPageStatus: null,
      otp: '',
      isReadyToPayByGoogle:  false,
      number_of_inquire_retry: 3,
      interval_between_inquire_retry_in_seconds: 15,
      receiptId: '',
      qrCodeString: null,
      merchantId: '',
      paymentId: '',
      isFailed: false,
      isApplePaySupported: false,
      _onResize: null,
      _onPageShow: null,
      _onMessage: null,
      show_google_pay: false,
      merchantName: '',
      merchantNameAr: '',
      google_pay_merchant_id: '',
      merchantLogo: '',
      businessUrl: process.env.VUE_APP_MERCHANT_URL,
      cancelUrl: '',
      successUrl: '',
      isOpen: false,
      is3DSecureError: false,
      isMobile: false,
      isThawaniPay: true,
      show_apple_pay: false,
      isQRPay: false,
      isChecked: false,
      isSaveCardAllowed: false,
      isSuccess: false,
      showOtp: false,
      isLoading: false,
      isAutoSaveCard: false,
      isScanQRModalOpen: false,
      isThawaniPayModalOpen: false,
      isCybersourceDown: false,
      isOmanNetDown: false,
      isCheckboxSeen: false,
      totalAmount: 0,
      showCancelModal: false,
      timer: 59,
      show3dSecure: false,
      otpLoad: false,
      selectedTab: 'bank-card', // Default selected tab
    };
  },

  created() {
    EventBus.$on('languageChanged', this.resetForm);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
    EventBus.$off('languageChanged', this.resetForm);
  },

  computed: {
    checkboxClasses() {
      return {
        'custom-checkbox-label': !this.isChecked,
        'custom-checkbox-label bg-green-500 ': this.isChecked,
        'flex items-center justify-center w-6 h-6 cursor-pointer': true,
      };
    },

    formattedTime() {
      const minutes = Math.floor(this.timer / 60);
      const seconds = this.timer % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
        2,
        '0',
      )}`;
    },

    btnClasses() {
      return {
        downloadBtnDisable: !this.isChecked,
        downloadBtn: this.isChecked,
        'flex items-center justify-center w-6 h-6 cursor-pointer ': true,
      };
    },

    QRAreaClasses() {
      return {
        QRareaDisable: !this.isChecked,
        QRareaenable: this.isChecked,
        'border-2 border-dashed border-gray-300 mb-2 text-center p-0 lg:p-4 relative':
          true,
      };
    },

    isRtl() {
      return this.$i18n.locale === 'ar';
    },
  },

  beforeUnmount() {
    this.unregisterGlobalListeners();
    if (this.scriptEl && this.scriptEl.parentNode) {
      this.scriptEl.parentNode.removeChild(this.scriptEl);
    }
    this.paymentsClient = null;
  },

  methods: {
      isGooglePaySupportedInThisBrowser() {
      // Payment Request API must exist
      if (!window.PaymentRequest) return false;

      // Optional: only allow on Android (Google Pay)
      const ua = navigator.userAgent || '';
      if (!/Android/i.test(ua)) return false;

      return true;
      },
    async setup() {
      // 1) Validate route early and bail if invalid
      if (!this.$route?.query?.key) {
        await this.$router.push({ path: '/404' });
        return;
      }

      // 2) Light, fast checks
      this.detectApplePay();
      this.checkDevice();

      // 3) Listeners
      this.registerGlobalListeners();

      // 4) Heavy async init (GPay)
      // If it fails, don't crash the page
      try {
        if (this.isGooglePaySupportedInThisBrowser()) {
        this.initGooglePay();
        } else {
        this.show_google_pay = false;
        }
      } catch (e) {
        this.lastError = e?.message || String(e);
      }

      // 5) Timers/others
      this.startTimer();
    },

    detectApplePay() {
      this.isApplePaySupported = !!(
        window.ApplePaySession && ApplePaySession.canMakePayments()
      );
    },

    checkDevice() {
      const ua = navigator.userAgent || '';
      const isMobileUA = /Android|iPhone|iPad|iPod/i.test(ua);
      const isSmallScreen = window.innerWidth <= 768;
      this.isMobile = isMobileUA && isSmallScreen;
    },

    registerGlobalListeners() {
      if (!this._onResize) this._onResize = () => this.checkDevice();
      if (!this._onPageShow)
        this._onPageShow = (evt) => {
          if (evt.persisted) window.location.reload();
        };
      if (!this._onMessage)
        this._onMessage = this.handleWindowMessage.bind(this);

      window.addEventListener('resize', this._onResize, { passive: true });
      window.addEventListener('pageshow', this._onPageShow);
      window.addEventListener('message', this._onMessage);
    },

    unregisterGlobalListeners() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._onPageShow)
        window.removeEventListener('pageshow', this._onPageShow);
      if (this._onMessage)
        window.removeEventListener('message', this._onMessage);
    },

    async handleWindowMessage(event) {
      const allowedOrigins = [
        process.env.VUE_APP_BASE_URL,
        process.env.VUE_APP_CARDINAL_DATA_COLLECTION_URL,
      ].filter(Boolean);

      if (!allowedOrigins.includes(event.origin)) return;

      // Cardinal data-collection payload
      if (event.origin === process.env.VUE_APP_CARDINAL_DATA_COLLECTION_URL) {
        try {
          const data =
            typeof event.data === 'string'
              ? JSON.parse(event.data)
              : event.data;
          if (data?.SessionId) await this.EnrollAuthentication(data.SessionId);
        } catch {
          /* ignore malformed payloads */
        }
        return;
      }

      if (event.data === '1' || event.data === '0') {
        await this.confirm3ds2Payment(event.data === '1');
      }
    },

    loadGooglePayScript() {
      return new Promise((resolve, reject) => {
        if (window.google?.payments?.api) return resolve();
        this.scriptEl = document.createElement('script');
        this.scriptEl.src = 'https://pay.google.com/gp/p/js/pay.js';
        this.scriptEl.async = true;
        this.scriptEl.onload = () => resolve();
        this.scriptEl.onerror = () => reject(new Error('Failed to load pay.js'));
        document.head.appendChild(this.scriptEl);
      });
    },

    getIsReadyToPayRequest() {
      return {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
          {
            type: 'CARD',
            parameters: {
            allowedAuthMethods: ["CRYPTOGRAM_3DS"],
            allowedCardNetworks: ["MASTERCARD", "VISA"],
            billingAddressRequired: true
            },
            tokenizationSpecification: {
              type: 'DIRECT',
              parameters: {
                protocolVersion: 'ECv2',
                publicKey: this.PUBLIC_KEY_BASE64,
              },
            },
          },
        ],
        merchantInfo: {
          merchantId: '',
        },
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          totalPrice: '00.00',
          currencyCode: 'OMR',
          countryCode: 'OM',
        },
      };
    },

    getCardPaymentMethod() {
      return {
        type: 'CARD',
        parameters: {
          allowedAuthMethods: ['CRYPTOGRAM_3DS'],
          allowedCardNetworks: ['MASTERCARD', 'VISA'],
          billingAddressRequired: true,
        },
        tokenizationSpecification: {
          type: 'DIRECT',
          parameters: {
            protocolVersion: 'ECv2',
            publicKey: String(this.PUBLIC_KEY_BASE64),
          },
        },
      };
    },
    getPaymentDataRequest() {
      return {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [plain(this.getCardPaymentMethod())],
        merchantInfo: {
          merchantId: '' + this.google_pay_merchant_id,
        },
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          totalPrice: '' + (this.totalAmount / 1000).toFixed(2),
          currencyCode: 'OMR',
          countryCode: 'OM',
        },
      };
    },
    async initGooglePay() {
      try {
        await this.loadGooglePayScript();
        this.paymentsClient = new window.google.payments.api.PaymentsClient({
          environment: 'PRODUCTION', //PRODUCTION
        });

        const isReadyToPayRequest = this.getIsReadyToPayRequest();
        const response = await this.paymentsClient.isReadyToPay(isReadyToPayRequest);
         this.show_google_pay = response?.result;
        if (response.result) {
          const button = this.paymentsClient.createButton({
            onClick: this.onGooglePaymentButtonClicked,
            buttonType: 'plain',
            buttonColor: 'black',
            buttonSizeMode: 'fill',
            buttonBorderType: 'default_border',
            buttonRadius: 4,
            allowedPaymentMethods: [this.getCardPaymentMethod()],
          });
          button.id = 'gpay-btn';
          this.$refs.buttonContainer.innerHTML = '';
          this.$refs.buttonContainer.appendChild(button);
         }else {
           this.show_google_pay = false;
         }
      } catch (e) {
        this.lastError = e?.message || String(e);
      }
    },
    async onGooglePaymentButtonClicked() {
      if (this.inFlight) return;
      this.inFlight = true;
      try {
        const req = plain(this.getPaymentDataRequest());

        const pd = await this.paymentsClient.loadPaymentData(req);
        const token = pd?.paymentMethodData?.tokenizationData?.token;
        this.statusMsg = '';
        this.purchaseLoad = true;
        try {
          const result = this.authorizeGooglePayPaymentAsync(token)
            .then((result) => {
              this.isLoading = true;
              if (result.success === true) {
                this.purchaseLoad = false;
                this.isSuccess = true;
                this.isLoading = false;
                setTimeout(() => {
                  window.location.href = this.successUrl;
                }, 1000);
              } else {
                this.purchaseLoad = false;
                this.isSuccess = false;
                this.isLoading = false;
                this.is3DSecureError = true;
              }
            })
            .catch((error) => {
              console.error('Error:', error); // Handle errors if any
            });
        } catch (error) {
          console.error('Payment authorization failed:', error);
        }
      } catch (err) {
        console.error('loadPaymentData error', err);
        this.lastError = JSON.stringify(err, null, 2);
        if (err?.statusCode !== 'CANCELED')
          this.statusMsg = 'Payment failed or canceled.';
        // else this.statusMsg = '';
          else {
      this.statusMsg = '';
    }
      } finally {
        this.inFlight = false;
      }
    },

    openPaReqInIframe() {
      this.showIframe = true;

      // simulate pa_req HTML from your API
      const paReqHtml = `
    <!DOCTYPE html>
    <html>

    <body>
      <h3>Redirecting...</h3>
      <form id="submissionForm" action="https://certecomm.omannet.om/gateway/authorize" method="POST">
        <input type="hidden" name="digest" value="12345" />
        <input type="hidden" name="sessionId" value="abcde" />
      </form>
      <script>document.getElementById("submissionForm").submit();<\/script>
          </body>
          </html>
        `;

      // inject pa_req into iframe
      this.$nextTick(() => {
        const iframe = this.$refs.paReqIframe;
        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(paReqHtml);
        doc.close();
      });
    },

    closeIframe() {
      this.showIframe = false;
    },

    formatAmount(amount) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      }).format(amount);
    },

    startApplePaySession() {
      const paymentRequest = {
        countryCode: 'OM',
        currencyCode: 'OMR',
        total: {
          label: '' + this.merchantName,
          amount: '' + (this.totalAmount / 1000).toFixed(3),
        },
        supportedNetworks: ['visa', 'masterCard'],
        merchantCapabilities: ['supports3DS'],
      };

      const session = new ApplePaySession(3, paymentRequest);

      session.onvalidatemerchant = (event) => {
        this.purchaseLoad = true;
        this.validateMerchant(event.validationURL)
          .then((merchantSession) =>
            session.completeMerchantValidation(merchantSession),
          )
          .catch(() => {
            this.purchaseLoad = false;
            session.abort();
          });
      };

      session.oncancel = () => {
        session.abort();
        this.purchaseLoad = false;
        this.isSuccess = false;
        this.isLoading = false;
      };

      session.onpaymentauthorized = async (event) => {
        const payment = event.payment;
        this.purchaseLoad = true;
        try {
          const result = this.authorizeApplePayPayment(payment)
            .then((result) => {
              this.isLoading = true;
              if (result.success === true) {
                this.purchaseLoad = false;
                this.isSuccess = true;
                this.isLoading = false;
                session.completePayment(ApplePaySession.STATUS_SUCCESS);
                setTimeout(() => {
                  window.location.href = this.successUrl;
                }, 1000);
              } else {
                this.purchaseLoad = false;
                this.isSuccess = false;
                this.isLoading = false;
                session.completePayment(ApplePaySession.STATUS_FAILURE);
                session.abort();
              }
            })
            .catch((error) => {
              console.error('Error:', error); // Handle errors if any
            });
        } catch (error) {
          console.error('Payment authorization failed:', error);
          session.completePayment(ApplePaySession.STATUS_FAILURE);
        }
      };

      session.begin();
    },

    async validateMerchant(validationURL) {
      try {
        const params = {
          session: this.$route.params.session,
          key: this.$route.query.key,
          validation_url: validationURL,
        };
        const response = await checkout.ValidateMerchantAsync(params);
        const result = await response.data;
        this.purchaseLoad = false;
        this.isSuccess = false;
        this.isLoading = false;
        return result;
      } catch (error) {
        throw error;
      }
    },

    async authorizeApplePayPayment(paymentData) {
      try {
        const params = {
          session: this.$route.params.session,
          key: this.$route.query.key,
          token: paymentData.token,
        };
        const response = await checkout.authorizeApplePayPaymentAsync(params);
        const result = await response.data;
        return result;
      } catch (error) {
        throw error;
      }
    },

    async authorizeGooglePayPaymentAsync(token) {
      try {
        const params = {
          session: this.$route.params.session,
          key: this.$route.query.key,
          token: token,
        };
        const response = await checkout.authorizeGooglePayPaymentAsync(params);
        const result = await response.data;
        return result;
      } catch (error) {
        throw error;
      }
    },

    async processApplePayPaymentBase64(paymentData) {
      try {
        const paymentDataString = JSON.stringify(paymentData.token.paymentData);
        const paymentDataBase64 = btoa(paymentDataString);
        const response = await checkout.processApplePayPaymentBase64(
          this.$route.params.session,
          this.$route.query.key,
          paymentDataBase64,
        );
        if (!response.ok) {
          throw new Error('Payment processing failed');
        }
        return response.json();
      } catch (error) {
        console.error('Error processing Apple Pay payment (Base64):', error);
        throw error;
      }
    },

    processPayment(payment) {
      // Send payment to your server for processing
      return fetch('/process-payment', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payment),
      })
        .then((response) => response.json())
        .then((data) => data.success);
    },

    confirmCancel() {
      this.showScanQRModal = false;
    },

    resetForm() {
      // Reset the form using Vue's form validation methods or manually
      if (this.$refs.paymentForm) {
        this.$refs.paymentForm.reset(); // Assuming you have a reset method
      }
    },

    // isMobileDevice() {
    //   const userAgent = navigator.userAgent || navigator.vendor || window.opera
    //   const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i
    //   return mobileRegex.test(userAgent.toLowerCase())
    // },

    selectTab(tab) {
      this.selectedTab = tab;
      this.$emit('selectedTabData', {
        number_of_inquire_retry: 3,
        interval_between_inquire_retry_in_seconds: 15,
        selectedTab: this.selectedTab,
      });
    },

    refreshSession(tab) {
      this.selectedTab = tab;
      this.$emit('refreshSession', {
        isrefreshSession: true,
        selectedTab: this.selectedTab,
      });
    },

    closeModal() {
      this.showOtp = false;
      this.purchaseLoad = false;
    },

    downloadQR() {},

    beforeDestroy() {
      clearInterval(this.interval);
    },

    startTimer() {
      this.interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(this.interval);
        }
      }, 1000);
    },

    cardChanged(typeFromCleave) {
  const n = (this.cardInformation.cardNumber || '').replace(/\s/g, '');

  // your rule: any card starting with 6 or 9 => 'maal'
  if (/^[69]/.test(n)) {
    this.cardType = 'maal';
    return;
  }

  // optional: explicitly set visa/mastercard from digits
  if (/^4/.test(n)) return (this.cardType = 'visa');
  if (/^(5[1-5]|2(2[2-9]\d|[3-6]\d{2}|7([01]\d|20)))/.test(n)) return (this.cardType = 'mastercard');

  // otherwise use Cleave’s built-in type
  this.cardType = typeFromCleave || 'unknown';
    },

    CancelModal() {
      this.showCancelModal = !this.showCancelModal;
    },

    dSecureModal() {
      this.show3dSecure = !this.show3dSecure;
      if (!this.show3dSecure) {
        this.purchaseLoad = false;
        this.receipt_id = '';
        this.payment_id = '';
      }
    },

    async confirm3ds2Payment(isSuccess) {
      this.show3dSecure = false;
      this.receipt_id = '';
      this.payment_id = '';
      this.purchaseLoad = false;

      if (isSuccess) {
        this.isSuccess = true;
        setTimeout(() => {
          window.location.href = this.successUrl;
        }, 1000);
      } else {
        this.isSuccess = false;
        this.is3DSecureError = true;
        this.isFailed = true;
      }
    },

    async cancelSession() {
      try {
        this.isCancel = true;
        const response = await checkout.cancelSessionAsync(
          this.$route.params.session,
          this.$route.query.key,
        );
        if (response.status === 200) {
          window.location.href = this.cancelUrl;
          this.isCancel = false;
        }
      } catch (ex) {
        alert("You can't cancel in process transaction");
        this.isCancel = false;
      }
    },

    InitiatePayment() {
      this.isFailed = false;
      this.$refs.paymentForm.validate().then(async (success) => {
        if (!success) {
          if (this.cardType === 'unknown') {
            this.$refs.form.setErrors({
              card: ['Card number is invalid'],
            });
          }
          return;
        }
        try {
          this.purchaseLoad = true;
          const response = await checkout.InitializePaymentAsync(
            this.$route.params.session,
            this.$route.query.key,
            this.cardInformation,
          );

          if (response.data.code === 2100) {
            this.isSuccess = true;
            setTimeout(() => {
              window.location.href = this.successUrl;
            }, 1000);

            // OmanNet
          } else if (response.data.code === 2101) {
            this.showOtp = true;
            this.startTimer();
            this.otp = '';
            this.hash = response.data.data.hash;
            this.receiptId = response.data.data.receipt_id;
            this.paymentId = response.data.data.payment_id;
            return;

            // CyberSource
          } else if (response.data.code === 2107) {
            openPaReqInIframe(response.data.data.next_action.pa_req);
          } else if (response.data.code === 2102) {
            // Start the Device Data collection procedure
            this.merchantId = response.data.data.merchant_id;
            this.receiptId = response.data.data.receipt_id;

            const form = document.createElement('form');
            form.target = 'cardinal-collection-iframe';
            form.method = 'POST';
            form.action = response.data.data.device_data_collection_url;

            const accessTokenElement = document.createElement('input');
            accessTokenElement.type = 'hidden';
            accessTokenElement.value = response.data.data.access_token;
            accessTokenElement.name = 'JWT';
            form.appendChild(accessTokenElement);

            document.body.appendChild(form);
            form.submit();
            form.remove();

            // Remove the existing element (if any)
            if (document.getElementById('deviceFingerprint') != null) {
              document.getElementById('deviceFingerprint').remove();
            }

            const deviceFingerPrintScript =
              document.createElement('script');
            deviceFingerPrintScript.id = 'deviceFingerprint';
            deviceFingerPrintScript.type = 'text/javascript';
            deviceFingerPrintScript.src =
              'https://h.online-metrix.net/fp/tags.js?org_id=' +
              this.cyberSourceOrganizationId +
              '&session_id=' +
              this.merchantId +
              this.receiptId;
            document.body.appendChild(deviceFingerPrintScript);

            // Remove the existing element (if any)
            if (document.getElementById('deviceFingerprintNoScript') != null) {
              document.getElementById('deviceFingerprintNoScript').remove();
            }

            const deviceFingerprintNoScript =
              document.createElement('noscript');
            deviceFingerprintNoScript.id = 'deviceFingerprintNoScript';

            const deviceFingerPrintIFrame = document.createElement('iframe');
            deviceFingerPrintIFrame.style =
              'width: 100px; height: 100px; border:0; position: absolute; top: -500px;';
            deviceFingerPrintIFrame.src =
              'https://h.online-metrix.net/fp/tags.js?org_id=' +
              this.cyberSourceOrganizationId +
              '&session_id=' +
              this.merchantId +
              this.receiptId;
            deviceFingerPrintIFrame.id = 'deviceFingerprintIFrame';

            deviceFingerprintNoScript.appendChild(deviceFingerPrintIFrame);
            document.body.appendChild(deviceFingerprintNoScript);
            return;
          } else {
            this.is3DSecureError = true;
            // this.$refs.paymentForm.setErrors({
            //   card: [this.$t('validation.card_declined')]
            // })
          }

          this.purchaseLoad = false;
        } catch (ex) {
          this.purchaseLoad = false;
        }
      });
    },

    async confirmPayment(isDebit, isSuccess) {
      if (isSuccess) {
        if (isDebit) {
          this.showOtp = false;
          this.receipt_id = '';
          this.payment_id = '';
          this.otp = '';
          this.isSuccess = true;
          this.purchaseLoad = false;
          this.otpLoad = false;
        } else {
          this.show3dSecure = false;
          this.receipt_id = '';
          this.payment_id = '';
          this.isSuccess = true;
          this.purchaseLoad = false;
        }
        setTimeout(() => {
          window.location.href = this.successUrl;
        }, 1000);
      } else {
        if (isDebit) {
          this.showOtp = false;
          this.receipt_id = '';
          this.payment_id = '';
          this.otp = '';
          this.isSuccess = false;
          this.purchaseLoad = false;
          this.otpLoad = false;
        } else {
          this.show3dSecure = false;
          this.receipt_id = '';
          this.payment_id = '';
          this.isSuccess = false;
          this.purchaseLoad = false;
        }
        this.isFailed = true;
      }
    },

    async EnrollAuthentication(referenceId) {
      try {
        const response = await checkout.EnrollAuthenticationAsync(
          this.receiptId,
          referenceId,
        );

        if (response.data.success) {
          if (response.data.data.step_up_url == null) {
            const validateAuthenticationResponse =
              await checkout.ValidateAuthenticationAsync(
                'Validate without OTP',
                response.data.data.authentication_transaction_id,
                response.data.data.receipt_id,
              );
            await this.confirm3ds2Payment(
              validateAuthenticationResponse.data.success,
            );
          } else {
            this.receiptId = response.data.data.receipt_id;
            this.merchantId = response.data.data.merchant_id;

            // Remove the existing element (if any)
            if (document.getElementById('deviceFingerprint') != null) {
              document.getElementById('deviceFingerprint').remove();
            }

            const deviceFingerPrintScript =
              document.createElement('script');
            deviceFingerPrintScript.id = 'deviceFingerprint';
            deviceFingerPrintScript.type = 'text/javascript';
            deviceFingerPrintScript.src =
              'https://h.online-metrix.net/fp/tags.js?org_id=' +
              this.cyberSourceOrganizationId +
              '&session_id=' +
              this.merchantId +
              this.receiptId;
            document.body.appendChild(deviceFingerPrintScript);

            const form = document.createElement('form');
            form.target = 'payment-iframe';
            form.method = 'POST';
            form.action = response.data.data.step_up_url;

            const jwtElement = document.createElement('input');
            const mdElement = document.createElement('input');

            jwtElement.type = 'hidden';
            jwtElement.value = response.data.data.access_token;
            jwtElement.name = 'JWT';

            mdElement.type = 'hidden';
            mdElement.value = this.receiptId;
            mdElement.name = 'MD';

            form.appendChild(jwtElement);
            form.appendChild(mdElement);
            document.body.appendChild(form);
            form.submit();
            form.remove();

            this.show3dSecure = true;
          }
        } else {
          this.is3DSecureError = true;
          // this.$refs.paymentForm.setErrors({
          //   card: [this.$t('validation.card_declined')]
          // })
          this.purchaseLoad = false;
        }
      } catch (ex) {
        this.purchaseLoad = false;
      }
    },

    async ProceedWithOTP() {
      const result = await this.$refs.otpForm.validate();
      if (!result) {
        return;
      }
      try {
        this.otpLoad = true;
        const OTPResponse = await checkout.AuthorizedPaymentAsync(
          this.$route.params.session,
          this.$route.query.key,
          this.receiptId,
          this.paymentId,
          this.otp,
        );
        if (OTPResponse.data.success) {
          await this.confirmPayment(true, true);
        } else {
          if (OTPResponse.data.code === 4206) {
            this.$refs.paymentForm.setErrors({
              card: [this.$t('validation.card_otp_failed')],
            });
          } else {
            // this.$refs.paymentForm.setErrors({
            //   card: [this.$t('validation.card_declined')]
            // })
            this.is3DSecureError = true;
          }
          this.receipt_id = '';
          this.payment_id = '';
          this.otp = '';
          this.otpLoad = false;
          this.showOtp = false;
          this.isSuccess = false;
          this.purchaseLoad = false;
        }
      } catch (ex) {
        this.receipt_id = '';
        this.payment_id = '';
        this.otp = '';
        this.otpLoad = false;
        this.showOtp = false;
        this.purchaseLoad = false;
      }
    },

    toggleSaveCardDetails(event) {
      this.isSaveCardDetails = event.target.checked;
      const label = event.target.nextElementSibling;
      const svg = label.querySelector('svg');
      if (event.target.checked) {
        label.classList.remove('bg-white', 'border-gray-300');
        label.classList.add('bg-green-500');
        svg.classList.remove('hidden');
        svg.classList.add('block');
      } else {
        label.classList.remove('bg-green-500');
        label.classList.add('bg-white', 'border-gray-300');
        svg.classList.remove('block');
        svg.classList.add('hidden');
      }
    },

    OtpModal() {
      this.showOtp = !this.showOtp;
      if (!this.showOtp) {
        this.purchaseLoad = false;
        this.otp = '';
        this.receipt_id = '';
        this.payment_id = '';
      }
    },

    proceedPaymentByDeepLinking(event) {
      this.isTermsAccepted = event.target.checked;
      const label = event.target.nextElementSibling;
      const svg = label.querySelector('svg');
      if (event.target.checked) {
        label.classList.remove('bg-white', 'border-gray-300');
        label.classList.add('bg-green-500');
        svg.classList.remove('hidden');
        svg.classList.add('block');
      } else {
        label.classList.remove('bg-green-500');
        label.classList.add('bg-white', 'border-gray-300');
        svg.classList.remove('block');
        svg.classList.add('hidden');
      }
    },

    acceptMPCSSPayment(event) {
      const label = event.target.nextElementSibling;
      const svg = label.querySelector('svg');
      if (event.target.checked) {
        label.classList.remove('bg-white', 'border-gray-300');
        label.classList.add('bg-green-500', 'border-green-500');
        svg.classList.remove('hidden');
        svg.classList.add('block');
      } else {
        label.classList.remove('bg-green-500', 'border-green-500');
        label.classList.add('bg-white', 'border-gray-300');
        svg.classList.remove('block');
        svg.classList.add('hidden');
      }
    },

    downloadPDF() {
      this.$nextTick(() => {
        const qrCodeArea = document.getElementById('qrCodeArea');
        html2canvas(qrCodeArea).then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF();
          const imgProps = pdf.getImageProperties(imgData);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
          pdf.save('QR_Code.pdf');
        });
      });
    },

    OpenThawaniApp() {
      const thawaniUrl =
        'thawani://openThawaniSession?session=' + this.$route.params.session;
      window.location.href = thawaniUrl;
    },

    retryApiCalls(retries, interval) {
      if (retries > 0) {
        setTimeout(() => {
          this.getCheckoutSessionDetails();
          this.retryApiCalls(retries - 1, interval);
        }, interval * 1000);
      }
    },
  },

  watch: {
    'cardInformation.cardNumber'(val) {
      const n = (val || '').replace(/\s/g, '');
       if (/^(6690|9512)/.test(n)) { this.cardType = 'maal'; return; }
      if (/^4/.test(n))         { this.cardType = 'visa'; return; }
      if (/^(5[1-5]|2(2[2-9]\d|[3-6]\d{2}|7([01]\d|20)))/.test(n)) {
        this.cardType = 'mastercard'; return;
      }
      this.cardType = 'unknown';
    },
    sessionData: {
      immediate: true,
      handler(newVal) {
        if (newVal.length > 0) {
          const data = newVal[0];
          this.totalAmount = data.total_amount;
          this.merchantName = data.merchant;
          this.google_pay_merchant_id = data.google_pay_merchant_id;
          this.cancelUrl = data.cancel_url;
          this.successUrl = data.success_url;
          this.number_of_inquire_retry = 3;
          this.interval_between_inquire_retry_in_seconds = 15;
          this.isSaveCardAllowed = data.is_save_card_allowed;
          this.isCheckboxSeen = this.isSaveCardAllowed;
          this.isAutoSaveCard = data.auto_save_card;
          this.paymentPageStatus = data.payment_page_status;
          this.isCybersourceDown = data.alert_cyber_source;
          this.isOmanNetDown = data.alert_oman_net;
          this.isThawaniPay = data.show_deeplink ?? '';
          this.show_apple_pay = data.show_apple_pay ?? '';
          this.show_google_pay = data.show_google_pay ?? '';
          this.PUBLIC_KEY_BASE64 = data.google_pay_public_key ?? '';
            if (this.isGooglePaySupportedInThisBrowser()) {
             this.initGooglePay();
            } else {
            this.show_google_pay = false;
            }
          // this.PUBLIC_KEY_BASE64 =
          //   'BFvhtL0dFUDND/NgP5h1aPTOVEPp1fYFW1ba7dS14gZ/82KibhBdTILbxUpQCliPv/H2yfXnruR4/5JtI5IGqYU=';

          this.isQRPay = data.show_qr ?? '';
          if (this.isAutoSaveCard === true) {
            this.isLoading = false;
            this.cardInformation.saveCard = true;
          }
        }
      },
    },

    qrCodeData: {
      immediate: true,
      handler(newVal) {
        this.qrCodeString = newVal;
        const canvas = this.$refs.qrcodeCanvas;
        if (this.qrCodeString) {
          QRCode.toCanvas(
            canvas,
            this.qrCodeString,
            { width: 200 },
            function (error) {
              if (error) console.error(error);
            },
          );
        }
      },
    },
  },

  async mounted() {
    await this.setup();
  },
};
</script>
<style scoped>
@import '../assets/css/tabs.css';

.currency-inline-btn {
  display: inline-flex;
  align-items: baseline;
  gap: 0.25em;
  direction: ltr;
}

.currency-icon-btn {
  width: auto;
  height: 0.85em;
  vertical-align: baseline;
  filter: brightness(0) invert(1);
}
</style>
